export default {
  common: {
    edit: 'Bewerken',
    yes: 'Ja',
    no: 'Nee',
    or: 'of',
    search: 'Zoeken',
    none: 'Geen',
    save: 'Opslaan',
    error: 'Fout',
    reset: 'Reset',
    input: 'Invoer',
    cancel: 'Annuleren',
    next: 'Volgende',
    back: 'Terug',
    selectHeaders: 'Zichtbare kolommen selecteren',
    weekday: 'Weekdag',
    from: 'Van',
    delete: 'Verwijderen',
    to: 'Tot',
    deliveryAt: 'Bezorging om',
    ok: 'Ok',
    add: 'Toevoegen',
    disable: 'Uitschakelen',
    enable: 'Inschakelen',
    remove: 'Verwijderen',
    empty: 'Er is hier niets te zien.',
    selectToImport: 'Selecteer een bestand om te importeren',
    selectVenue: 'Selecteer een locatie.',
    import: 'Importeren',
    export: 'Exporteren',
    legacyExport: 'Legacy Export',
    file: 'Bestand',
    apply: 'Toepassen',
    applySelectedFilters: 'Geselecteerde filters toepassen',
    filters: 'Filter',
    orders: 'Bestellingen',
    overview: 'Overzicht',
    others: 'Overig',
    skip: 'Overslaan',
    time: 'Tijd',
    date: 'Datum',
    register: 'Registreren',
    submit: 'Verzenden',
    confirmDelete: 'Weet u zeker dat u dit item wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    form: {
      file: 'Bestand',
    },
    all: 'Alles',
    single: 'Enkel',
    teedeli: 'Teedeli',
    selectItems: 'Selecteer ten minste één item.',
    noSelection: 'Geen selectie',
    description: 'Beschrijving',
    invoice: 'Factuur',
    name: 'Naam',
    tag: 'Tag',
    tags: 'Tags',
    test: 'Test',
    shoppingCart: 'Winkelwagen',
    send: 'Versturen',
    recommendation: 'Aanbeveling',
    generate: 'Genereren',
    selectAll: 'Alles selecteren',
    singleImageAllowed: 'Slechts één afbeelding is toegestaan!',
    imageFilesOnly: 'Alleen afbeeldingsbestanden zijn toegestaan!',
    fileSizeExceed: 'Bestandsgrootte overschrijdt het maximum van {max}MB!',
    imageMaxSizeNotice: 'De afbeelding mag maximaal {max}MB groot zijn!',
    copyId: 'ID kopiëren',
    copiedToClipboard: 'Gekopieerd naar klembord!',
    imagesDragAndDrop: 'Sleep & Drop',
    browseFiles: 'Blader door bestanden',
    videoPreview: 'Video Voorbeeld',
    fileName: 'Bestandsnaam',
    fileSize: 'Bestandsgrootte',
    videoDuration: 'Videoduur',
    videoResolution: 'Videoresolutie',
    uploadProgress: 'Uploadvoortgang',
    uploadVideo: 'Video uploaden',
    videoFileOnly: 'Alleen videobestanden!',
    dragAndDropVideoHere: 'Sleep je video hierheen',
    uploadComplete: 'Upload voltooid',
  },
  languageField: {
    add: 'Andere toevoegen',
    picker: 'Taal',
  },
  countries: {
    de: 'Duitsland',
    au: 'Oostenrijk',
    fr: 'Frankrijk',
    li: 'Liechtenstein',
    lu: 'Luxemburg',
    ch: 'Zwitserland',
    es: 'Spanje',
    is: 'IJsland',
    ic: 'Canarische Eilanden',
    pt: 'Portugal',
    cz: 'Tsjechië',
    nl: 'Nederland',
    be: 'België',
    no: 'Noorwegen',
    dk: 'Denemarken',
    se: 'Zweden',
    ae: 'VAE',
    lt: 'Litouwen',
    fi: 'Finland',
    gb: 'Verenigd Koninkrijk',
    it: 'Italië',
  },
  toolbar: {
    selectOrSearchVenue: 'Selecteer of zoek locatie...',
    noSelection: 'Geen Locatie Geselecteerd',
    copyShortId: 'Korte ID kopiëren',
  },
  masterTypes: {
    web: 'Web',
    terminal: 'Terminal',
  },
  login: {
    caption: 'Smoothr is de snelkoppeling voor de digitalisering van uw restaurant.',
  },
  dashboard: {
    index: 'Dashboard',
    totalSum: 'Totale Omzet',
    totalVenues: 'Resultaten van {total} locaties worden getoond.',
    totalNetSum: 'Totale Netto Omzet',
    orderSum: 'Aantal Bestellingen',
    provisionSum: 'Provision',
    form: {
      customerGroup: 'Selecteer Klantengroep',
    },
    table: {
      total: 'Totaal',
      totalNet: 'Totaal Netto',
      numberOfOrders: 'Aantal Bestellingen',
      venue: 'Locatie',
      readableId: 'Korte ID',
      provision: 'Provision',
    },
  },
  provision: {
    index: 'Provision',
    overview: 'Overzicht',
    claim: 'Provision Claimen',
    select: 'Selecteer of zoek een locatie om betalingen te tonen',
    claimHelp: 'Selecteer een locatie en een periode om de provision te claimen.',
    success: 'Succes',
    sum: 'Som',
    waiting: 'Wachtend',
    notClaimed: 'Niet geclaimd',
    notification: {
      claiming: 'Provision zal worden geclaimd. Vernieuw de site na een paar minuten om de wijzigingen te zien.',
    },
    form: {
      venue: 'Locatie',
    },
    table: {
      sum: 'Totaalprijs',
      method: 'Methode',
      status: 'Status',
      createdAt: 'Gemaakt Op',
      provision: 'Provision Status',
      provisionClaimedAt: 'Geclaimd Op',
    },
  },
  inventory: {
    index: 'Inventaris',
    overview: 'Overzicht',
    stock: 'Voorraad',
    product: 'Producten',
    add: 'Aanmaken',
    form: {
      stock: 'Voorraad',
      product: 'Selecteer producten',
    },
    table: {
      stock: 'Voorraad',
      inventoryItems: 'Producten',
      createdAt: 'Gemaakt Op',
    },
  },
  company: {
    index: 'Bedrijf',
    overview: 'Overzicht',
    general: 'Details',
    deliveryAddress: 'Bezorgadres',
    invoiceAddress: 'Factuuradres',
    add: 'Aanmaken',
    create: 'Aanmaken',
    edit: 'Bewerken',
    form: {
      venue: 'Locatie',
      name: 'Naam',
      companyCode: 'Bedrijfscode',
      email: 'E-Mail',
      phoneNumber: 'Telefoonnummer',
      vatNumber: 'BTW',
      orderMinimum: 'Minimale Bestelwaarde',
      subsidy: 'Subsidie',
      subsidyOrderMinimum: 'Minimale Bestelwaarde Subsidie',
      paymentMethod: 'Betaalmethode',
      iban: 'IBAN',
      storeDiscount: 'Winkelkorting (%)',
      isPaidByCompany: 'Betaald door Bedrijf',
      city: 'Stad',
      area: 'Dichtstbijzijnde Stad',
      street: 'Straat',
      streetAddress: 'Straatadres',
      number: 'Nummer',
      company: 'Bedrijf',
      postalCode: 'Postcode',
      gpsManualInput: 'Handmatige Invoer (GPS-coördinaten)',
      gpsCorrect: 'GPS-coördinaten OK?',
      latitude: 'Breedtegraad',
      longitude: 'Lengtegraad',
      deliveryTime: 'Bezorgtijd',
      useDeliveryAddressAsInvoice: 'Gebruik Bezorgadres voor Factuuradres',
    },
    table: {
      venue: 'Locatie',
      name: 'Naam',
      createdAt: 'Gemaakt Op',
      companyCode: 'Bedrijfscode',
      email: 'E-Mail',
      phoneNumber: 'Telefoonnummer',
      vatNumber: 'BTW',
    },
    tabs: {
      general: 'Algemeen',
      openingHours: 'Openingstijden',
      deliveryTime: 'Bezorgtijd',
    },
    notification: {
      emptyOpeningHours: 'De openingstijden zijn leeg. Stel de openingstijden in.',
    },
  },
  uiBanner: {
    index: 'Banner',
    overview: 'Overzicht',
    general: 'Details',
    add: 'Aanmaken',
    create: 'Aanmaken',
    edit: 'Bewerken',
    empty:
      // tslint:disable-next-line:max-line-length
      'Het lijkt erop dat u nog geen UI Banners heeft toegevoegd. Maak nu uw eerste UI Banner aan!',
  },
  uiCard: {
    index: 'Kaart',
    overview: 'Overzicht',
    general: 'Details',
    add: 'Aanmaken',
    create: 'Aanmaken',
    edit: 'Bewerken',
    empty:
      // tslint:disable-next-line:max-line-length
      'Het lijkt erop dat u nog geen UI Kaarten heeft toegevoegd. Maak nu uw eerste UI Kaart aan!',
  },
  uiSlider: {
    index: 'Slider',
    overview: 'Overzicht',
    general: 'Details',
    add: 'Aanmaken',
    create: 'Aanmaken',
    edit: 'Bewerken',
    empty:
      // tslint:disable-next-line:max-line-length
      'Het lijkt erop dat u nog geen UI Sliders heeft toegevoegd. Maak nu uw eerste UI Slider aan!',
  },
  notification: {
    form: 'Vul het formulier in.',
    400: 'Het verzoek was niet geldig.',
    401: 'Uw inloggegevens zijn niet geldig.',
    422: 'Er was een onverwachte validatiefout. Controleer het formulier.',
    404: 'De opgevraagde bron kon niet worden gevonden.',
    403: 'U bent niet gemachtigd om deze pagina te bekijken.',
    500: 'Er was een interne serverfout.',
    mfa: 'De MFA-code is ongeldig.',
    unknown: 'Er was een onbekende fout.',
    downloadInProgress:
      'Uw download wordt voorbereid. U kunt nog steeds op de site navigeren. De download van uw bestand begint automatisch zodra het klaar is.',
    downloadFailed: 'Een van uw downloads is mislukt. Probeer het later opnieuw.',
    downloadSuccess: 'Uw download is klaar!',
    gpsError:
      'GPS-positie voor het opgegeven adres is niet gevonden. Wijzig het adres of voer handmatig GPS-coördinaten in.',
    successfulDownload: 'De export is naar uw e-mailadres verzonden',
    retryCheckoutIntegrationAction: 'Opnieuw proberen succesvol',
    needOpeningHours: 'Stel eerst openingstijden in!',
    needDeliveryHours: 'Stel eerst bezorgtijden in!',
    visibleOptionGroupError: 'Deze optiegroep is verplicht. Er moet minstens 1 optie-artikel zichtbaar zijn',
  },
  gender: {
    index: 'Geslacht',
    male: 'Man',
    female: 'Vrouw',
    other: 'Anders',
  },
  displayModes: {
    default: 'Standaard',
    launcher: 'Launcher',
    smartPicker: 'Smart Picker',
    detailOverlay: 'Detail Overlay',
    detailDialog: 'Detail Dialoog',
    grid: 'Raster',
    pagedGrid: 'Gepagineerd Raster',
    circle: 'Cirkel',
    topSeller: 'Topverkoper',
    matrix: 'Matrix',
    banner: 'Banner',
    drinkFlavor: 'Dranksmaak',
    toggleButton: 'Schakelknop',
    flavor: 'Smaak',
    checkbox: 'Selectievakje',
    radio: 'Keuzerondje',
    code: 'Code',
  },
  displayIdentifiers: {
    extra: 'Extra',
    extra15: 'Extra 15',
    extra30: 'Extra 30',
    extraCheese15: 'Extra Kaas 15',
    extraCheese30: 'Extra Kaas 30',
    size: 'Maat',
    size15: 'Maat 15',
    size30: 'Maat 30',
    cheese: 'Kaas',
    kids: 'Kinderen',
    salad: 'Salade',
    bread: 'Brood',
    cookie1: '1x Koekje',
    cookie3: '3x Koekje',
    cookie12: '12x Koekje',
    chips: 'Chips',
    sauce: 'Saus',
    drink: 'Drank',
    water: 'Water',
    tea: 'Thee',
    hotBeverages: 'Warme Dranken',
    menu: 'Menu',
    main: 'Hoofd',
    sub: 'Sub',
    wrap: 'Wrap',
    sides: 'Bijgerechten',
    fullPrice: 'Volledige Prijs',
    inverse: 'Inverse',
    code: 'Code',
  },
  venueSelector: {
    title: 'Selecteer Locatie',
    search: 'Selecteer een locatie',
    back: 'Terug naar locaties',
  },
  currency: {
    eur: 'Euro',
    chf: 'Zwitserse Frank',
    isk: 'IJslandse kroon',
    czk: 'Tsjechische kroon',
    aed: 'VAE Dirham',
    sek: 'Zweedse Kroon',
    dkk: 'Deense Kroon',
    nok: 'Noorse Kroon',
    gbp: 'Britse Pond',
  },
  routes: {
    venue: {
      index: 'Locatie',
      create: 'Locatie Aanmaken',
      createSimple: 'Locatie Aanmaken',
      copyFoodcard: 'Foodcard kopiëren',
      edit: 'Locatie Bewerken',
      panic: 'Panic Instellingen',
      editSimple: 'Locatie Bewerken',
      verify: 'Locatie Verifiëren',
      publish: 'Locatie Publiceren',
      migrate: 'Locatie Migreren',
      sync: 'Locatie Synchroniseren',
      copy: 'Locatie Kopiëren',
    },
    screensaver: {
      index: 'Screensaver',
      create: 'Screensaver aanmaken',
      edit: 'Screensaver bewerken',
    },
    employeeNotification: {
      index: 'Medewerker Notificatie',
      create: 'Medewerker Notificatie aanmaken',
    },
    banner: {
      index: 'Banners',
      create: 'Banner aanmaken',
      edit: 'Banner bewerken',
    },
    venueLabel: {
      index: 'Locatie Label',
      create: 'Locatie Label Aanmaken',
      edit: 'Locatie Label Bewerken',
    },
    sepa: {
      index: 'SEPA instellingen',
    },
    productCombos: {
      index: 'Productcombinaties',
    },
    promo: {
      index: 'Promotiecodes',
      create: 'Promotiecode Aanmaken',
      createTeedeli: 'Teedeli Promotiecode Aanmaken',
      edit: 'Promotiecode Bewerken',
      export: 'Promotiecode Exporteren',
      exportTeedeli: 'Teedeli Promotiecode Exporteren',
      disable: 'Promotiecodes Uitschakelen',
      createMultiple: 'Meerdere Promotiecodes Aanmaken',
    },
    cupCode: {
      index: 'Bekercodes',
      create: 'Bekercode Aanmaken',
      edit: 'Bekercode Bewerken',
    },
    coupon: {
      index: 'Coupon (verouderd)',
      create: 'Coupon Aanmaken',
      edit: 'Coupon Bewerken',
      export: 'Coupon Exporteren',
      disable: 'Coupon Uitschakelen',
      createMultiple: 'Meerdere Coupons Aanmaken',
    },
    maintenance: {
      index: 'Onderhoud',
    },
    provision: {
      index: 'Provision',
    },
    inventory: {
      index: 'Inventaris Beheren',
      create: 'Inventaris Aanmaken',
      edit: 'Inventaris Bewerken',
    },
    payment: {
      index: 'Betaling',
    },
    home: {
      index: 'Home',
    },
    reporting: {
      index: 'Rapportage',
    },
    register: {
      index: 'Franchisenemer Informatie',
      venue: 'Locaties Registreren',
      success: 'Registratie Succesvol',
    },
    analytics: {
      index: 'Analyse',
    },
    sales: {
      index: 'Verkoop',
    },
    salesOverview: {
      index: 'Verkoopoverzicht',
    },
    receipt: {
      index: 'Bonnen',
    },
    eposJobs: {
      index: 'EPOS Taken',
    },
    sanifairLogs: {
      index: 'Sanifair Logs',
    },
    automatedReports: {
      index: 'Geautomatiseerde Rapporten',
      create: 'Geautomatiseerd Rapport Aanmaken',
    },
    billing: {
      index: 'Facturatie',
    },
    userExport: {
      index: 'Gebruikerexport',
    },
    activityLogExport: {
      index: 'Activiteitenlogs',
    },
    lightspeed: {
      index: 'Lightspeed',
      success: 'Autorisatie succesvol',
      error: 'Autorisatie mislukt',
    },
    statistics: {
      index: 'Statistieken',
    },
    error: {
      index: 'Fout',
      notFound: '404 Pagina Niet Gevonden',
      forbidden: '401 Verboden',
    },
    user: {
      index: 'Gebruiker',
      create: 'Gebruiker Aanmaken',
      edit: 'Gebruiker Bewerken',
      createSimple: 'Gebruiker Aanmaken',
      editSimple: 'Gebruiker Bewerken',
    },
    role: {
      index: 'Rol',
      create: 'Rol Aanmaken',
      edit: 'Rol Bewerken',
    },
    customerGroupProprty: {
      index: 'Klantengroep Eigenschap',
      create: 'Klantengroep Eigenschap Aanmaken',
      edit: 'Klantengroep Eigenschap Bewerken',
    },
    foodcard: {
      index: 'Foodcard Importeren',
    },
    printer: {
      index: 'Printer',
      edit: 'Printer Bewerken',
    },
    tag: {
      index: 'Tag',
      create: 'Tag Aanmaken',
      edit: 'Tag Bewerken',
    },
    information: {
      index: 'Informatie',
      create: 'Informatie Aanmaken',
      edit: 'Informatie Bewerken',
    },
    constrain: {
      index: 'Handelsgroep',
      create: 'Handelsgroep Aanmaken',
      edit: 'Handelsgroep Bewerken',
    },
    printGroups: {
      index: 'Printgroepen',
      create: 'Printgroepen Aanmaken',
      edit: 'Printgroepen Bewerken',
    },
    dashboard: {
      index: 'Dashboard',
    },
    auditing: {
      index: 'Audit',
    },
    enrollments: {
      index: 'Inschrijvingen',
    },
    table: {
      index: 'Tafel',
      create: 'Tafel Aanmaken',
      edit: 'Tafel Bewerken',
    },
    category: {
      index: 'Categorie',
      create: 'Categorie Aanmaken',
      edit: 'Categorie Bewerken',
    },
    subscriptionCategories: {
      index: 'Abonnementscategorie',
      create: 'Abonnementscategorie Aanmaken',
      edit: 'Abonnementscategorie Bewerken',
    },
    subscription: {
      index: 'Abonnement',
      create: 'Abonnement Aanmaken',
      edit: 'Abonnement Bewerken',
    },
    membership: {
      index: 'Lidmaatschap',
      create: 'Lidmaatschap Aanmaken',
      edit: 'Lidmaatschap Bewerken',
    },
    article: {
      index: 'Artikel',
      create: 'Artikel Aanmaken',
      edit: 'Artikel Bewerken',
      editSimple: 'Artikel Bewerken',
    },
    articleManager: {
      index: 'Artikelbeheerder',
    },
    recommendation: {
      index: 'Winkelwagen Aanbeveling',
      create: 'Winkelwagen Aanbeveling Aanmaken',
      edit: 'Winkelwagen Aanbeveling Bewerken',
    },
    option: {
      index: 'Optie',
      create: 'Optie Aanmaken',
      edit: 'Optie Bewerken',
      editSimple: 'Optie Bewerken',
    },
    customer: {
      index: 'Klant',
      create: 'Klant Aanmaken',
      edit: 'Klant Bewerken',
      import: 'Klant Importeren',
    },
    translation: {
      index: 'Vertaling',
    },
    loyaltyPrograms: {
      index: "Loyaliteitsprogramma's",
      create: 'Loyaliteitsprogramma Aanmaken',
      edit: "Loyaliteitsprogramma's Bewerken",
    },
    sync: {
      index: 'Synchronisatie',
      create: 'Synchronisatie Aanmaken',
      upsell: 'Upsells Synchronisatie Aanmaken',
    },
    aggregatorSyncs: {
      index: 'Synchronisaties',
    },
    company: {
      index: 'Bedrijven',
      create: 'Bedrijf Aanmaken',
      edit: 'Bedrijf Bewerken',
    },
    ui: {
      banner: {
        index: 'Banners',
        create: 'Banner Aanmaken',
        edit: 'Banner Bewerken',
      },
      card: {
        index: 'Kaarten',
        create: 'Kaart Aanmaken',
        edit: 'Kaart Bewerken',
      },
      slider: {
        index: 'Sliders',
        create: 'Slider Aanmaken',
        edit: 'Slider Bewerken',
      },
    },
    campaign: {
      index: 'Campagnes',
      create: 'Campagne Aanmaken',
      edit: 'Campagne Bewerken',
    },
    releases: {
      index: 'Releases',
      create: 'Release Aanmaken',
      edit: 'Release Bewerken',
    },
    upsells: {
      index: 'Upsells',
    },
    depositRule: {
      index: 'Statiegeld Regels',
      create: 'Statiegeld Regel Aanmaken',
      edit: 'Statiegeld Regel Bewerken',
    },
    healthCheck: {
      index: 'Gezondheidscheck',
      create: 'Gezondheidscheck Aanmaken',
      edit: 'Gezondheidscheck Bewerken',
    },
    forgotPassword: 'Wachtwoord Vergeten',
    resetPassword: 'Wachtwoord Resetten',
  },
  weekdays: {
    monday: 'Maandag',
    mondayShort: 'Ma',
    tuesday: 'Dinsdag',
    tuesdayShort: 'Di',
    wednesday: 'Woensdag',
    wednesdayShort: 'Wo',
    thursday: 'Donderdag',
    thursdayShort: 'Do',
    friday: 'Vrijdag',
    fridayShort: 'Vr',
    saturday: 'Zaterdag',
    saturdayShort: 'Za',
    sunday: 'Zondag',
    sundayShort: 'Zo',
  },
  orderStatus: {
    none: 'Standaard',
    created: 'Aangemaakt',
    in_preparation: 'In Voorbereiding',
    ready: 'Klaar',
    in_payment: 'In Betaling',
    awaiting_confirmation: 'Wacht op Bevestiging',
    done: 'Voltooid',
    failed: 'Mislukt',
    validated: 'Gevolideerd',
    cancelled_by_waiter: 'Geannuleerd door Ober',
    cancelled_by_customer: 'Geannuleerd door Klant',
  },
  checkoutIntegrationStatus: {
    sent: 'Verzonden',
    received: 'Ontvangen',
    verified: 'Geverifieerd',
    finalized: 'Afgerond',
    rejected: 'Afgewezen',
    canceled: 'Geannuleerd',
    postponed: 'Uitgesteld',
  },
  stockMode: {
    none: 'Gedeactiveerd',
    toggle: 'Geactiveerd',
    disable_only: 'Alleen artikelen deactiveren',
    enable_only: 'Alleen artikelen activeren',
  },
  mainCategories: {
    dish: 'Gerecht',
    beverage: 'Drank',
    other: 'Overig',
  },
  autoReset: {
    none: 'Geen',
    morning: 'Ochtend',
    noon: 'Middag',
    evening: 'Avond',
    midnight: 'Middernacht',
  },
  customerGroups: {
    default: 'standaard',
    defaultInPreparation: 'standaard_in_voorbereiding',
    defaultWebApp: 'standaard_web_app',
    subway: 'Subway',
    db: 'Deutsche Bahn',
    lunchroom: 'Lunchroom',
    weilands: 'Weilands',
    cinemaxx: 'Cinemaxx',
    fbf: 'Food By Friends',
    district: 'District',
    slush: 'Slush',
    kochloeffel: 'Kochlöffel',
    immergruen: 'Immergrün',
    myMonza: 'MyMonza',
    subwayFr: 'Subway Frankrijk',
    subwayLu: 'Subway Luxemburg',
    subwayTerminal: 'Subway Terminal',
    aspasia: 'Aspasia',
    cotidiano: 'Cotidiano',
    bigburger: 'BigBurger',
    koos: 'KOOS',
    deanAndDavid: 'Dean and David',
    frittenwerk: 'Frittenwerk',
    purino: 'Purino',
    ottosBurger: 'Otto´s Burger',
    threeMensKebab: '3 Mens Kebab',
    perfectDay: 'Perfect Day',
    hausmanns: 'Hausmanns',
    doenerwerk: 'Dönerwerk',
    foodlounge: 'Foodlounge',
    mado: 'Mado',
    depot: 'Depot',
    nordsee: 'Nordsee',
    jamies: 'Jamies',
    burgerKing: 'Burger King',
    burgerKingD: 'Burger King D',
    atlantikFisch: 'Atlantik Fisch',
    moschmosch: 'Moschmosch',
    kamps: 'Kamps',
    coffeeFellows: 'Coffee Fellows',
    hofbrauhaus: 'Hofbrauhaus',
    saray: 'Saray',
    starbucks: 'Starbucks',
    dimatest: 'Dima Test',
    maloa: 'Maloa',
    werk5: 'Werk 5',
    epi: 'EPI',
    iamlove: 'IAMLOVE',
    beetsAndRoots: 'Beets and Roots',
    beetsAndRootsSecond: 'Beets and Roots 2',
    losteria: "L'Osteria",
    losteriaAt: "L'Osteria Austria",
    shiso: 'Shiso',
    snackElize: 'Snack Elize',
    tabilo: 'TUR RES',
    tabiloSim: 'TUR Simphony',
    turAbnahmeRes: 'TUR Abnahme RES',
    turAbnahmeSim: 'TUR Abnahme Sim',
    turAutohof: 'TUR Autohof',
    turAbnahmeAutohof: 'TUR Abnahme Autohof',
    turSegafredo: 'TUR Segafredo',
    effeGold: 'Effe & Gold',
    lacantine: 'La cantine',
    eam: 'Eam',
    naupaka: 'Naupaka',
    sportsbar: 'Sportsbar',
    cigkoftem: 'Cigkoftem',
    sushisupply: 'Sushi Supply',
    the_ash: 'The Ash',
    markthalle: 'Markthalle',
    sashimi: 'Sashimi',
    bonboncha: 'Bonboncha',
    hulala: 'Hulala',
    backwerk_schweiz: 'Backwerk Zwitserland',
    backwerkCh: 'Backwerk CH',
    backfactory: 'Backfactory',
    teedeli: 'Teedeli',
    wohlfuhler: 'Wohlfuhler',
    asiaGourmet: 'Asia Gourmet',
    frittenwerkSecond: 'Frittenwerk 2',
    ricerepublic: 'RiceRepublic',
    goodbytz: 'Goodbytz',
    piratenBurger: 'Piraten Burger',
    tournesol: 'Tournesol',
    brezelKoenig: 'Brezelkönig',
    vincentVegan: 'Vincent Vegan',
    papais: 'Papais',
    theCup: 'The Cup',
    marseilleFoodMarket: 'Marseille Food Market',
    olearys: 'Olearys',
    iceland: 'IJsland',
    tableDot: 'Table Dot',
    sevenByBat: 'Seven by BAT',
    breakBurger: 'Break Burger',
    wok: 'Wok',
    oakberry: 'Oakberry',
    trz: 'TRZ',
    monkeyBurger: 'Monkey Burger',
    pastaFee: 'Pasta Fee',
    potatoe: 'Potatoe',
    pibose: 'Pibosa',
    shiangMing: 'Shiang Ming',
    antonAndAnni: 'Anton&Anni',
    kaisin: 'Kaisin',
    dunkin: 'Dunkin',
    sushiTomo: 'Sushi Tomo',
    spiga: 'SPIGA',
    rastpark: 'Euro Rastpark',
    ahoi: 'Ahoi',
    eatdoori: 'Eatdoori',
    burroBurro: 'Burro Burro',
    brammibalDonuts: 'Brammibal Donuts',
    milanoVice: 'Milano Vice',
    sspSliceIt: 'SSP Slice It',
    keladamsKebab: 'Keladams Kebab',
    autohof24: 'Autohof 24',
    reishauer: 'Reishauer',
    pastaLich: 'Pasta Lich',
    eintrachtFrankfurt: 'Eintracht Frankfurt',
    topgolf: 'Topgolf',
    klausKebab: 'Klaus Kebab',
    josefs: 'Josefs',
    burritoCompany: 'Burrito Company',
    zeroKebab: 'Zero Kebab',
    nhasCityChicken: 'Nhas City Chicken',
    mrSha: 'Mr. Sha',
    bollwerk: 'Bollwerk',
    wyniger: 'Wyniger',
    burgerVision: 'Burger Vision',
    picklBurger: 'Pickl Burger',
    maisonMatcha: 'Maison Matcha',
    enriqueTomas: 'Enrique Tomas',
    versaillesCastle: 'Versailles Castle',
    randys: 'Randys',
    saz: 'Saz',
    hawaiianPokeBowls: 'Hawaiian Poke Bowls',
    luca: 'Luca',
    olearysNordic: "O'Learys Nordic",
    trattoriaTavolare: 'Trattoria Tavolare',
    carlsbergSportsBar: 'Carlsberg Sports Bar',
    bistro: 'Bistro',
    jomfruin: 'Jomfruin',
    tigerstaden: 'Tigerstaden',
    bjornsBackyard: 'Bjorns Backyard',
    burgerKingCh: 'Burger King CH',
    gelatoBar: 'Gelato Bar',
    sspVincentVegan: 'SSP Vincent Vegan',
    elKiosko: 'El Kiosko',
    camden: 'Camden',
    pizzaHut: 'Pizza Hut',
    spareRib: 'Spare Rib',
    lucullus: 'Lucullus',
    bonbird: 'Bonbird',
    sspPizzaHut: 'SSP Pizza Hut',
    elevenBar: '11 Bar',
    theKissingGates: 'The Kissing Gates',
    gambrinus: 'Gambrinus',
    tabernnus: 'Tabernnus',
    jimis: 'Jimis',
    hensslerAtHome: 'Henssler At Home',
    dailyPizza: 'Daily Pizza',
    hunterBar: 'Hunter Bar',
    mogaTee: 'Moga Tee',
    grauholz: 'Grauholz',
    rabbagast: 'Rabbagast',
    craftNDraft: 'Craft n Draft',
    herfra: 'Herfra',
    cafeRitazza: 'Cafe Ritazza',
    heineken: 'Heineken',
    laBoutique: 'La Boutique',
    figlmueller: 'Figlmüller',
    dominosSwitzerland: 'Dominos Pizza CH',
    wildChildCoffee: 'Wild Child Coffee',
    schurter: 'Schurter',
    dirtyPatty: 'Dirty Patty',
    captainHook: 'Captain Hook',
    ingerslevs: 'Ingerslevs',
    thaqiCafeNuernberg: 'Thaqi Cafe Nürnberg',
    aramarkAsianBistrotConcept: 'Aramark Asian Bistrot Concept',
    theBab: 'The Bab',
    locoChicken: 'Loco Chicken',
    eatery77: 'Eatery 77',
    beshle: 'Beshle',
    feasty: 'Feasty',
    kantine11: 'Kantine 11',
  },
  deliverableOrderTypes: {
    foodspot: 'Foodspot',
    delivery: 'Bezorging',
  },
  error: {
    notFound: 'Sorry, de pagina kon niet worden gevonden.',
    forbidden: 'Verboden.',
    goHome: 'Ga Terug naar Start',
    forbiddenText: 'Ongeautoriseerd. U bent niet gemachtigd om deze pagina te bekijken.',
    notFoundText: 'De pagina die u zoekt kon niet worden gevonden.',
  },
  foodcard: {
    index: 'Foodcard Beheren',
    export_csv: 'Exporteer Foodcard (*.csv)',
    export_csv_de: 'DE Export Foodcard (*.csv)',
    import: 'Foodcard Importeren',
    importCvs: 'Importeer foodcard (*.csv)',
    importNutritionCsv: 'Importeer voedingswaarden (*.csv)',
    export_xlsx_de: 'DE Export Foodcard (*.xlsx)',
    importCvsWithArticleInfo: 'Importeer info van Artikelen (*.csv)',
  },
  home: {
    index: 'Home',
    welcome: 'Welkom!',
  },
  tag: {
    index: 'Tags Beheren',
    overview: 'Overzicht',
    add: 'Tag Toevoegen',
    empty:
      // tslint:disable-next-line:max-line-length
      'Het lijkt erop dat u nog geen tags heeft toegevoegd. Maak uw eerste tag aan om ze toe te wijzen aan uw artikelen en opties.',
    form: {
      name: 'Naam',
      identifier: 'Identificatie',
      sort: 'Sortering',
      recommendationTag: 'Aanbeveling Tag',
    },
    table: {
      name: 'Naam',
      identifier: 'Identificatie',
      sort: 'Sortering',
      recommendationTag: 'Aanbeveling Tag',
    },
  },
  depositRule: {
    index: 'Statiegeld Regels Beheren',
    overview: 'Overzicht',
    add: 'Statiegeld Regel Toevoegen',
    empty: 'Het lijkt erop dat u nog geen statiegeld regels heeft toegevoegd. Maak uw eerste statiegeld regel aan.',
    form: {
      priority: 'Prioriteit',
      deposit: 'Statiegeld',
      startedAt: 'Van',
      endedAt: 'Tot',
    },
    table: {
      priority: 'Prioriteit',
      deposit: 'Statiegeld',
      startedAt: 'Van',
      endedAt: 'Tot',
    },
  },
  information: {
    index: 'Informatie Beheren',
    overview: 'Overzicht',
    add: 'Informatie Toevoegen',
    edit: 'Informatie Bewerken',
    addAction: 'Actie Toevoegen',
    removeAction: 'Actie Verwijderen',
    actions: 'Acties',
    empty:
      'Het lijkt erop dat u nog geen informatie heeft toegevoegd. Maak uw eerste informatie aan om klanten te informeren over aankomende evenementen en promoties.',
    actionTypes: {
      primary: 'Primair',
      secondary: 'Secundair',
      cancel: 'Annuleren',
    },
    form: {
      image: 'Afbeelding',
      title: 'Titel',
      from: 'Van',
      to: 'Tot',
      description: 'Beschrijving',
      url: 'Url',
      action: 'Actie',
      actionType: 'Actie Type',
      actionValue: 'Actie Waarde',
      actionHtmlContent: 'HTML Inhoud',
      actionName: 'Actie Naam',
    },
    table: {
      title: 'Titel',
      description: 'Beschrijving',
      from: 'Van',
      to: 'Tot',
      url: 'Url',
    },
  },
  role: {
    index: 'Rollen Beheren',
    overview: 'Overzicht',
    create: 'Rol Aanmaken',
    edit: 'Rol Bewerken',
    copy: 'Rol Kopiëren',
    empty:
      'Het lijkt erop dat u nog geen rollen heeft aangemaakt. Maak uw eerste rol aan om gebruikers gedetailleerde toegang te geven.',
    help: 'Let op! Wijzig een rol alleen als u absoluut zeker weet wat u doet. Houd er ook rekening mee dat systeemrollen niet kunnen worden gewijzigd.',
    add: 'Rol Toevoegen',
    table: {
      name: 'Naam',
      slug: 'Slug',
      isSystem: 'Systeemrol',
      permissions: 'Rechten',
    },
    form: {
      name: 'Naam',
      slug: 'Slug (unieke identificatie)',
      isSystem: 'Systeemrol (indien actief, kan rol niet worden gewijzigd.)',
      permissions: 'Rechten',
    },
    notification: {
      roleCopyStarted:
        'Het kopieerproces van de rol is gestart. U wordt doorgestuurd naar de pagina voor het aanmaken van rollen met vooraf ingevulde gegevens. Pas indien nodig wijzigingen toe en klik op Opslaan.',
      roleCopyFailed: 'Het kopieerproces van de rol is mislukt. Probeer het opnieuw.',
    },
  },
  customerGroupProprty: {
    index: 'Klantengroep Eigenschap Beheren',
    overview: 'Overzicht',
    create: 'Klantengroep Eigenschap Aanmaken',
    edit: 'Klantengroep Eigenschap Bewerken',
    add: 'Klantengroep Eigenschap Toevoegen',
    importTemplate: 'Klant Factuursjabloon Importeren',
    table: {
      name: 'Naam',
      template: 'Factuursjabloon',
      defaultOrderStatus: 'Standaard Bestelstatus',
      initialOrderStatusStandard: 'Initiële Bestelstatus Standaard',
      initialOrderStatusTerminal: 'Initiële Bestelstatus Terminal',
    },
    form: {
      customerGroupName: 'Naam',
      getDefaultOrderStatus: 'Standaard Bestelstatus',
      getInitialOrderStatusStandard: 'Initiële Bestelstatus Standaard',
      getInitialOrderStatusTerminal: 'Initiële Bestelstatus Terminal',
      getInitialOrderStatusVirtual: 'Initiële Bestelstatus Virtueel',
    },
  },
  venueLabel: {
    index: 'Locatie Labels Beheren',
    overview: 'Overzicht',
    create: 'Locatie Label Aanmaken',
    edit: 'Locatie Label Bewerken',
    empty: 'Het lijkt erop dat u nog geen locatie labels heeft aangemaakt.',
    add: 'Label Toevoegen',
    table: {
      name: 'Naam',
      slug: 'Slug',
      venues: 'Locaties',
    },
    form: {
      name: 'Naam',
      image: 'Afbeelding',
      slug: 'Slug (unieke identificatie)',
      venues: 'Locaties',
      visibleTo: 'Zichtbaar voor Locaties',
    },
  },
  recommendation: {
    index: 'Winkelwagen Aanbeveling',
    create: 'Winkelwagen Aanbeveling Aanmaken',
    edit: 'Winkelwagen Aanbeveling Bewerken',
    overview: 'Overzicht',
    score: 'Score',
    scoreMatrix: 'Score Matrix',
    scoreMatrixNotFound: 'Score Matrix niet gevonden',
    best: 'Beste',
    worst: 'Slechtste',
  },
  user: {
    index: 'Gebruikers Beheren',
    overview: 'Overzicht',
    create: 'Gebruiker Aanmaken',
    changePassword: 'Wachtwoord Wijzigen',
    help: 'Let op! Wijzig een gebruiker alleen als u absoluut zeker weet wat u doet. Anders kan het zijn dat een gebruiker niet kan inloggen.',
    edit: 'Gebruiker Bewerken',
    add: 'Gebruiker Toevoegen',
    table: {
      name: 'Naam',
      email: 'E-Mail',
      code: 'Code',
      venues: 'Locaties',
      role: 'Rol',
    },
    form: {
      name: 'Naam',
      customerGroup: 'Klantengroep',
      linkedCustomerGroup: 'Gekoppelde Klantengroep',
      email: 'E-Mail',
      password: 'Wachtwoord',
      passwordConfirmation: 'Wachtwoord Bevestigen',
      venues: 'Locaties',
      venueLabels: 'Locatie Labels',
      role: 'Rol',
    },
  },
  printer: {
    index: 'Printers Beheren',
    overview: 'Overzicht',
    edit: 'Printer Bewerken',
    customerGroup: 'Klantengroep',
    empty: 'Het lijkt erop dat er nog geen printers zijn.',
    table: {
      name: 'Naam',
      articleCount: 'Aantal Artikelen',
      venue: 'Locatie',
      startedAt: 'Gestart om',
      activated: 'Geactiveerd',
      lastSignal: 'Laatste Signaal',
      latestActivity: 'Laatste Activiteit',
      restart: 'Herstarten',
      restartInProgress: 'Herstarten bezig...',
      order: 'Bestelling',
    },
    form: {
      articles: 'Artikelen',
      name: 'Naam',
    },
  },
  customer: {
    index: 'Klanten Beheren',
    overview: 'Overzicht',
    edit: 'Klant Bewerken',
    create: 'Klant Aanmaken',
    add: 'Klant Toevoegen',
    import: 'Klant Importeren',
    empty: 'Het lijkt erop dat u nog geen klanten heeft toegevoegd. Maak uw eerste klant aan.',
    table: {
      userUid: 'Gebruiker UID',
      name: 'Naam',
      email: 'E-Mail',
      qr: 'QR-Code',
    },
    form: {
      email: 'E-Mail',
      gender: 'Geslacht',
      name: 'Volledige Naam',
      city: 'Stad',
      street: 'Straat',
      number: 'Nummer',
      postalCode: 'Postcode',
    },
  },
  constrain: {
    index: 'Handelsgroepen Beheren',
    overview: 'Overzicht',
    add: 'Handelsgroep Toevoegen',
    empty:
      'Het lijkt erop dat u nog geen handelsgroepen heeft toegevoegd. Maak uw eerste handelsgroep aan om ze toe te wijzen aan uw artikelen.',
    form: {
      name: 'Naam',
      identifier: 'Identificatie',
      active: 'Actief',
    },
    table: {
      name: 'Naam',
      identifier: 'Identificatie',
      active: 'Actief',
    },
  },
  printGroups: {
    index: 'Printgroepen Beheren',
    overview: 'Overzicht',
    add: 'Printgroepen Toevoegen',
    empty:
      'Het lijkt erop dat u nog geen Printgroepen heeft toegevoegd. Maak uw eerste Printgroepen aan om ze toe te wijzen aan uw artikelen.',
    form: {
      name: 'Naam',
      identifier: 'Identificatie',
      active: 'Actief',
    },
    table: {
      name: 'Naam',
      identifier: 'Identificatie',
      active: 'Actief',
    },
  },
  languages: {
    de: 'Duits',
    en: 'Engels',
    fr: 'Frans',
    nl: 'Nederlands',
    it: 'Italiaans',
    pl: 'Pools',
    es: 'Spaans',
    tr: 'Turks',
    zh: 'Chinees',
    ru: 'Russisch',
    da: 'Deens',
    ja: 'Japans',
    is: 'IJslands',
    pt: 'Portugees',
    cz: 'Tsjechisch (NIET GEBRUIKEN)',
    cs: 'Tsjechisch',
    ar: 'Arabisch',
    el: 'Grieks',
    ko: 'Koreaans',
    th: 'Thais',
    vi: 'Vietnamees',
    hi: 'Hindi',
    ur: 'Urdu',
    tl: 'Tagalog',
    id: 'Indonesisch',
    no: 'Noors',
    sv: 'Zweeds',
    lt: 'Litouws',
    fi: 'Fins',
  },
  legalForms: {
    ag: 'AG',
    gmbh: 'GmbH',
    ltd: 'UG',
    kg: 'KG',
    pe: 'Eenmanszaak',
    other: 'Andere',
    sa: 'SA',
    sarl: 'SARL',
    eurl: 'EURL',
    sas: 'SAS',
    autres: 'AUTRES',
    se: 'SE',
    seCoKg: 'SE & Co. KG',
  },
  periods: {
    daily: 'Dagelijks',
    weekly: 'Wekelijks',
    monthly: 'Maandelijks',
    never: 'Nooit',
  },
  locTypes: {
    bar: 'Bar',
    club: 'Club',
    restaurant: 'Restaurant',
    db: 'Deutsche Bahn',
    cinema: 'Bioscoop',
    other: 'Anders',
  },
  paymentTypes: {
    cc: 'Creditcard',
    pp: 'PayPal',
    sepa: 'SEPA',
    sb: 'Sofort Banking',
    bankTransfer: 'Bankoverschrijving',
    paypal: 'PayPal',
    cash: 'Contant',
    credit_card: 'Creditcard',
    balance: 'Saldo',
    pos: 'POS',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    sofortbanking: 'Sofort Banking',
    wallee: 'Wallee',
    postfinance: 'PostFinance',
    postfinance_card: 'PostFinance Card',
    reka: 'Reka',
    twint: 'Twint',
    luncheck: 'Luncheck',
    boncard: 'Boncard',
    alipay: 'Alipay',
    wechat: 'WeChat Pay',
    worldline: 'Worldline',
    worldline_raw: 'Worldline (Raw)',
    tac: 'TAC',
    ccv: 'CCV',
    zero_payment: 'Zero Payment',
    wolt: 'Wolt',
    ec: 'EC',
    girocard: 'Girocard',
    mastercard: 'Mastercard',
    amex: 'American Express',
    visa: 'Visa',
    visa_e: 'Visa Electron',
    vpay: 'V PAY',
    jcb: 'JCB',
    maestro: 'Maestro',
    other: 'Anders',
    vr_sepa: 'VR SEPA',
    bank_transfer: 'Bankoverschrijving',
    diners: 'Diners Club',
    discover: 'Discover',
    subsidy: 'Subsidie',
    piggy_gift_card: 'Piggy Cadeaukaart',
    piggy_prepaid_balance: 'Piggy Prepaid Saldo',
    miles_and_more: 'Miles & More',
    kost_card: 'KOST Card',
    worldline_mobile_apple_pay: 'Worldline Mobile Apple Pay',
    worldline_mobile_credit_card: 'Worldline Mobile Creditcard',
    worldline_mobile_google_pay: 'Worldline Mobile Google Pay',
    worldline_apple_pay: 'Worldline Apple Pay',
    worldline_credit_card: 'Worldline Creditcard',
    worldline_google_pay: 'Worldline Google Pay',
    ideal: 'iDEAL',
    meal_voucher_fr: 'Maaltijdcheque (FR)',
    bon_bon_gift_card: 'Bon Bon Cadeaukaart',
    deliveroo: 'Deliveroo',
    swish: 'Swish',
    vipps: 'Vipps',
    mobile_pay: 'Mobile Pay',
    dankort: 'Dankort',
    maxxvend: 'MAXXvend',
  },
  nav: {
    dashboard: 'Dashboard',
    auditing: 'Audit',
    enrollments: 'Inschrijvingen',
    foodcard: 'Foodcard',
    customer: 'Klanten',
    screensaver: 'Screensaver',
    venue: 'Locaties',
    venueLabel: 'Locatie Labels',
    productCombos: 'Productcombinaties',
    payment: 'Betalingen',
    user: 'Gebruiker',
    table: 'Tafels',
    tag: 'Tags',
    information: 'Informatie',
    sales: 'Verkoop',
    salesOverview: 'Verkoopoverzicht',
    printer: 'Printer',
    translation: 'Vertaling',
    tradegroup: 'Handelsgroepen',
    printGroups: 'Print Groepen',
    provision: 'Provision',
    inventory: 'Inventaris',
    statistic: 'Statistieken',
    analytic: 'Analyse',
    receipts: 'Bonnen',
    billing: 'Facturatie',
    userExport: 'Gebruikerexport',
    selectVenue: 'Selecteer locatie',
    category: 'Categorieën',
    subscriptionCategories: 'Abon. Categorie',
    subscription: 'Abonnement',
    membership: 'Lidmaatschapsniveau',
    article: 'Artikelen',
    articleManager: 'Artikelen & Opties Zichtbaarheid',
    recommendations: 'Aanbevelingen',
    option: 'Opties',
    reporting: 'Rapportage',
    import: 'Importeren',
    role: 'Rol',
    sepa: 'SEPA',
    maintenance: 'Onderhoud',
    promo: 'Promotiecodes',
    banner: 'Banners',
    tips: 'Fooien',
    eposJobs: 'EPOS taken',
    automatedReport: 'Geautomatiseerde Rapporten',
    coupon: 'Coupon (verouderd)',
    employeeNotification: 'Medewerker Notificatie',
    loyaltyPrograms: 'Loyaliteitsprogramma',
    seasonPass: 'Season Pass',
    automatedReports: 'Geautomatiseerde Rapporten',
    customerGroupProprty: 'Klantengroep',
    sanifairLogs: 'Sanifair Logs',
    cupCode: 'Bekercodes',
    activityLogExport: 'Activiteiten Log Export',
    sync: 'Synchronisatie',
    aggregatorSyncs: 'Aggregatie Synchronisatie',
    company: 'Bedrijven',
    promocodesAndLoyalty: 'Loyaliteit',
    customerInfo: 'Klantinfo',
    other: 'Overig',
    finances: 'Financiën',
    analytics: 'Analyse',
    syncAndLogs: 'Synchronisatie en Logs',
    uiComponents: 'UI Componenten',
    uiSlides: 'Slides',
    uiSlider: 'Slider',
    uiCard: 'Kaart',
    uiBanner: 'Banner',
    campaigns: 'Campagnes',
    releases: 'Releases',
    upsell: 'Upsells',
    depositRule: 'Statiegeld Regels',
    healthCheck: 'Gezondheidscheck',
  },
  auth: {
    logout: 'Uitloggen',
    login: 'Inloggen',
    forgotPassword: 'Wachtwoord Vergeten',
    forgotPasswordHint: 'Voer uw e-mailadres in en klik op wachtwoord resetten.',
    resetPassword: 'Wachtwoord Resetten',
    reset: 'Wachtwoord Resetten',
    security: 'Accountbeveiliging',
    form: {
      password: 'Wachtwoord',
      passwordHint:
        'Het wachtwoord moet minimaal 8 tekens lang zijn, 1 hoofdletter en 1 cijfer of speciaal teken bevatten.',
      passwordConfirmation: 'Wachtwoord Bevestigen',
      email: 'E-mail',
      otp: 'Eenmalige code',
    },
    mfaModal: {
      title: 'Goedkeuring vereist',
      description: 'Voer uw MFA-code in',
    },
    accountSecurity: {
      title: 'Accountbeveiliging',
      mfa: {
        title: 'Multi-factor-authenticatie (MFA)',
        description:
          'Multi-factor-authenticatie voegt een extra beveiligingslaag toe aan uw account door meer dan alleen het wachtwoord te vereisen voor inloggen en kritieke functies.',
        setup: 'Authenticator-app instellen',
        scan: 'Scan de QR-code met uw Authenticator-app.',
        enterCode: 'Na het scannen van de QR-code toont de app een code. Voer deze code hieronder in.',
        enterCodeShort: 'Voer uw MFA-code in:',
        backupCodesTitle: 'Backup-Codes',
        backupCodesExplanation:
          'Als multi-factor authenticatie actief is en u uw apparaat verliest, heeft u de backup-codes nodig om toegang te krijgen tot uw Lemin-account.',
        backupCodesDanger:
          'Zonder backup-codes moet u contact opnemen met onze ondersteuning en passend bewijs leveren zodat uw Lemin-account kan worden gereactiveerd. <br/><br/> We raden u aan de backup-codes te downloaden of te kopiëren en op een veilige plaats te bewaren. Elke backup-code is slechts één keer geldig en wordt na gebruik verwijderd.',
        copy: 'Kopiëren',
        download: 'Downloaden',
        print: 'Afdrukken',
        status: 'Status',
        active: 'Actief',
        notActive: 'Niet actief',
        deactivate: 'Deactiveren',
        showBackupCodes: 'Backup-codes tonen',
        regenerateBackupCodes: 'Backup-codes opnieuw genereren',
        deactivateMFATitle: 'Multi-factor-authenticatie deactiveren',
        deactivateMFADanger:
          'Om multi-factor-authenticatie opnieuw te gebruiken, moet u deze opnieuw instellen. Bestaande backup-codes worden na deactivering verwijderd. <br/><br/>Weet u zeker dat u wilt doorgaan?',
      },
    },
    notification: {
      forgotPassword:
        'Als we uw e-mailadres in ons systeem hebben gevonden, sturen we u een e-mail met een link om uw wachtwoord te resetten',
      resetPassword: 'Uw wachtwoord is gereset.',
      forbidden: 'U hebt geen toestemming om deze pagina te bekijken.',
      login: 'U bent succesvol ingelogd.',
      logout: 'U bent succesvol uitgelogd.',
      resetPasswordError: 'Uw token kon niet worden gevonden of het token is verlopen.',
      invalidMFACode: 'De MFA-code is ongeldig.',
    },
  },
  maintenance: {
    index: 'Onderhoud',
    status: 'Onderhoudsstatus',
    enable: 'Onderhoud Inschakelen',
    disable: 'Onderhoud Uitschakelen',
    enabled: 'Het systeem draait momenteel in onderhoudsmodus. Sommige services zijn mogelijk niet beschikbaar.',
    disabled: 'Alle systemen werken correct.',
  },
  register: {
    index: 'Registratie',
    account: 'Account',
    register: 'Registreren',
    success: 'Registratie Succesvol',
    addVenue: 'Locatie Toevoegen',
    removeVenue: 'Locatie Verwijderen',
    venue: 'Locaties Aanmaken',
    documentInfo:
      'Vul de volgende gegevens in om uw impressum, algemene voorwaarden en privacybeleid voor uw webshop te genereren. Deze documenten zijn noodzakelijk.',
    successText: 'Uw registratie was succesvol. We informeren u via e-mail wanneer uw locaties zijn aangemaakt.',
    location: 'Locatiegegevens',
    invoiceReceiver: 'Factuurontvanger',
    dialog: {
      venue: 'Wilt u een locatie aanmaken? Als u nee klikt, kunt u dit later alsnog doen.',
    },
    form: {
      venue: 'Locatie',
      name: 'Volledige Naam',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      phone: 'Telefoon',
      email: 'E-Mail',
      password: 'Wachtwoord (min. 6)',
      passwordHint:
        'Het wachtwoord moet minimaal 8 tekens lang zijn, 1 hoofdletter en 1 cijfer of speciaal teken bevatten.',
      passwordConfirmation: 'Wachtwoord Bevestigen (min. 6)',
      privacy: 'Ik ga akkoord met de Privacyverordening',
      privacyLink: 'Privacyverordening',
    },
    notification: {
      venue:
        'Uw nieuwe Locatie wordt binnen enkele minuten toegevoegd. Log uit en log over 3 minuten opnieuw in om uw nieuwe locatie te zien en te bewerken.',
    },
  },
  article: {
    index: 'Artikelen Beheren',
    create: 'Nieuw Artikel Aanmaken',
    edit: 'Artikel Bewerken',
    copy: 'Artikel Kopiëren',
    testFoodcard: 'Test foodcard',
    add: 'Artikel Toevoegen',
    availability: 'Beschikbaarheid',
    overview: 'Overzicht',
    selectArticle: 'Selecteer Artikel',
    selectCategory: 'Selecteer Categorie',
    general: 'Algemeen',
    prices: 'Prijzen',
    visibility: 'Zichtbaar',
    meta: 'Meta',
    measurement: 'Meting',
    media: 'Media',
    options: 'Opties',
    displayPrices: 'Prijzen Weergeven',
    mappings: 'Artikel Koppelingen',
    requirements: 'Artikel Vereisten',
    nutritions: 'Artikel Voedingswaarden',
    defaults: 'Artikel Standaarden',
    recommendations: 'Artikel Aanbevelingen',
    depArticles: 'Artikelen',
    availableHours: 'Beschikbare Uren',
    addGroupDependency: 'Afhankelijkheid Toevoegen',
    addGroupReverseDependency: 'Omgekeerde Afhankelijkheden Toevoegen',
    addMappingArticle: 'Koppelartikel Toevoegen',
    addDepArticles: 'Afhankelijkheidsartikelen Toevoegen',
    addReverseDepArticles: 'Omgekeerde Afhankelijkheidsartikelen Toevoegen',
    dependencies: 'Afhankelijkheden',
    reverseDependencies: 'Omgekeerde afhankelijkheden',
    addDefault: 'Standaard Toevoegen',
    split: 'Splitsen',
    standardPrices: 'Standaard Prijzen',
    preorderPrices: 'Voorbestel Prijzen',
    terminalPrices: 'Terminal Prijzen',
    standardAvailability: 'Standaard Beschikbaarheid',
    terminalAvailability: 'Terminal Beschikbaarheid',
    preorderAvailability: 'Voorbestel Beschikbaarheid',
    priceLockByType: 'Prijzen vergrendeld per besteltype (algemene prijsvergrendeling heeft voorrang)',
    webAvailability: 'Web Beschikbaarheid',
    cateringAvailability: 'Catering Beschikbaarheid',
    noVisibleArticlesNotice: 'Sorry! Deze optiegroep heeft geen zichtbare artikelen.',
    addRecommendation: 'Aanbeveling Toevoegen',
    price: 'Prijs',
    priceLowToHigh: 'Laag naar hoog',
    priceHighToLow: 'Hoog naar laag',
    visible: 'Zichtbaar',
    hide: 'Verbergen',
    fontColor: 'Lettertype Kleur',
    styleOption: 'Stijl Opties',
    borderColor: 'Randkleur',
    backgroundColor: 'Achtergrondkleur',
    style: 'Stijlen',
    loyaltyOptions: 'Loyaliteits Opties',
    openingHours: 'Openingstijden',
    manufacturer: 'Fabrikant',
    ingredients: 'Ingrediënten',
    dimension: 'Afmetingen',
    weightDetails: 'Gewichtsdetails',
    seeOriginal: 'Bekijk origineel artikel',
    displayIdentifiersOfOptions: 'Identificaties van opties weergeven',
    tagsOfArticle: 'Tags van artikel',
    helloTess: {
      hellotessApiBaseUrl: 'helloTESS! api url',
      hellotessApiKey: 'helloTESS! api key',
      success: 'Foodcard is geïmporteerd',
    },
    gastrofix: {
      gastrofixBusinessUnit: 'Business Unit',
      gastrofixApiKey: 'Gastrofix api key',
      gastrofixImportLanguage: 'Foodcard Taal',
      success: 'Foodcard is geïmporteerd',
    },
    simphony: {
      orgShortName: 'Organisatie Identificatie/Korte Naam',
      locRef: 'Locatie Identificatie',
      rvcRef: 'Revenue Center Identificatie',
      serviceUrl: 'Service URL',
      importLanguage: 'Foodcard Taal',
      success: 'Foodcard is geïmporteerd',
    },
    deliverect: {
      account: 'Deliverect Klant Account ID',
      menu: 'Menu ID',
      importLanguage: 'Foodcard Taal',
      success: 'Foodcard is geïmporteerd',
    },
    generalImport: {
      checkoutIntegration: 'Foodcard',
    },
    tabs: {
      general: 'Algemeen',
      media: 'Media',
      meta: 'Meta',
      options: 'Opties',
      prices: 'Prijzen',
      displayPrices: 'Prijzen Weergeven',
      availableHours: 'Beschikbare Uren',
      availability: 'Beschikbaarheid',
      allergens_and_additives: 'Allergenen en Toevoegingen',
      nutritions: 'Voedingswaarden',
      features: 'Kenmerken',
      style: 'Stijlen',
      wolt: 'Wolt',
      uberEats: 'Uber-Eats',
      jet: 'Jet',
      deliveroo: 'Deliveroo',
      visibility: 'Zichtbaarheid',
    },
    table: {
      name: 'Naam',
      stock: 'Voorraad',
      price: 'Prijs',
      active: 'Actief',
      assets: 'Afbeelding',
      internalNote: 'Interne Notitie',
      internalName: 'Interne Naam',
      category: 'Categorie',
      isControlArticle: 'Controle Artikel',
      availableHours: 'Beschikbare Uren',
      categoryAvailableHours: 'Categorie Beschikbare Uren',
      icon: 'Pictogram',
      banner: 'Banner',
      description: 'Beschrijving',
      number: 'Nummer',
      sortOrder: 'Sortering',
      gtin: 'GTIN',
      visible: 'Zichtbaar',
      rowsPerPage: 'Rijen Per Pagina',
      externalId: 'Externe ID',
      preorderDeliveryPrice: 'Voorbestel Bezorgprijs',
      preorderTakeAwayPrice: 'Voorbestel Afhaalprijs',
      terminalTakeAwayPrice: 'Terminal Afhaalprijs',
      terminalInsidePrice: 'Terminal Binnenprijs',
      tags: 'Tags',
      taxTakeaway: 'BTW Afhaal',
      taxInside: 'BTW Binnen',
      uber: 'Uber-Eats',
      wolt: 'Wolt',
      jet: 'Jet',
      uberEatsTakeawayEnabled: 'Uber Eats Afhaal Beschikbaar',
      uberEatsDeliveryEnabled: 'Uber Eats Bezorging Beschikbaar',
      woltVisibility: 'Wolt Zichtbaarheid',
      woltActive: 'Wolt Actief',
      jetTakeawayEnabled: 'Jet Afhaal Beschikbaar',
      jetDeliveryEnabled: 'Jet Bezorging Beschikbaar',
    },
    copyDialog: {
      sourceCategory: 'Bron Categorie',
      targetCategory: 'Doel Categorie',
      articles: 'Artikelen',
      venue: 'Selecteer Locatie',
      success: 'Artikel(en) is/zijn gekopieerd',
    },
    testFoodcardModal: {
      chunkSize: 'Aantal artikelen per bestelling',
      success: 'Foodcard test is succesvol gestart.',
      error: 'Foodcard test kon niet worden gestart.',
    },
    form: {
      name: 'Naam',
      internalName: 'Interne Naam',
      description: 'Beschrijving',
      price: 'Prijs',
      prices: 'Prijzen',
      type: 'Type',
      value: 'Waarde',
      emailDomain: 'E-Mail domein',
      bannerVideo: 'Video',
      kostPrice: 'KOST-Prijs',
      maxxvendPrice: 'MAXXvend-Prijs',
      dndCompany: 'DND Bedrijf',
      min: 'Min.',
      max: 'Max.',
      standardPrice: 'Standaard Prijs',
      insidePrice: 'Binnenprijs',
      enabledInFoodcard: 'Actief (indien niet actief, wordt het item niet toegevoegd aan het Wolt-menu)',
      deliveryPrice: 'Bezorgprijs',
      takeAwayPrice: 'Afhaalprijs',
      replacesMainArticle: 'Vervangt Hoofdartikel',
      gtin: 'GTIN (Global Trade Identifier Number)',
      externalId: 'Externe ID',
      internalNote: 'Interne Notitie',
      preparationTime: 'Voorbereidingstijd (in minuten)',
      plu: 'PLU',
      standardAvailability: 'Beschikbaar',
      insideAvailability: 'Beschikbaar binnen',
      takeAwayAvailability: 'Beschikbaar voor afhaal',
      deliveryAvailability: 'Beschikbaar voor bezorging',
      webAvailability: 'Beschikbaar',
      stock: 'Voorraad',
      image: 'Afbeelding',
      banner: 'Banner',
      icon: 'Pictogram',
      active: 'Actief',
      tags: 'Tags',
      group: 'Optiegroep',
      mainRecommendations: 'Hoofd Aanbevelingen',
      priceIsLocked: 'Prijs Vergrendeld (alle)',
      isNoticeable: 'Opvallend',
      isControlArticle: 'Controle Artikel',
      shortDescription: 'Korte Beschrijving',
      articles: 'Artikelen',
      article: 'Artikel',
      visible: 'Zichtbaar',
      printerSort: 'Printer Sortering',
      quantity: 'Aantal',
      constrains: 'Handelsgroepen',
      printGroups: 'Printgroepen',
      unit: 'Eenheid',
      amount: 'Hoeveelheid',
      rateable: 'Waardeerbaar',
      taxInside: 'BTW Binnen',
      taxTakeaway: 'BTW Afhaal',
      takeaway: 'Afhaal',
      delivery: 'Bezorging',
      inside: 'Binnen',
      displayPrice: 'Weergave Prijs',
      referencePrice: 'Referentie Prijs',
      referencePriceHint:
        'Normale verkoopprijs van het artikel. Voor aanbiedingsartikelen staat bij "Prijs" de aanbiedingsprijs — voer hier de normale prijs in zodat de oorspronkelijke prijs en korting correct worden weergegeven.',
      isPrintable: 'Afdrukbaar',
      isRateable: 'Waardeerbaar',
      info: 'Info',
      sort: 'Sortering',
      mappedArticle: 'Gekoppeld Artikel',
      code: 'Code',
      category: 'Categorie',
      number: 'Nummer',
      deposit: 'Statiegeld',
      fsk: 'FSK',
      alcoholPercentage: 'Alcohol (in Percentage)',
      caffeineMg: 'Cafeïne (mg)',
      main: 'Hoofdartikel',
      kcal: 'Kcal',
      options: 'Opties',
      optionGroup: 'Optiegroep',
      newName: 'Nieuwe naam',
      availableDateStart: 'Beschikbaar Vanaf Datum',
      availableDateEnd: 'Beschikbaar Tot Datum',
      maxItemsPerCart: 'Max. Items per Winkelwagen',
      articleRelativeBrand: 'Merk',
      loyaltyId: 'Loyaliteits ID',
      isPiggyLoyalty: 'Is Piggy Loyalty',
      redeemableAtCheckoutOnly: 'Inwisselbaar',
      piggyPointsNeeded: 'Piggy Punten Nodig (verouderd)',
      piggyRewardUuid: 'Piggy Beloning Uuid',
      requiredLoyaltyPoints: 'Vereiste loyaliteitspunten voor inwisseling',
      address: 'Adres',
      country: 'Land',
      visibility: 'Zichtbaarheid',
      company: 'Bedrijf',
      height: 'Hoogte (cm)',
      width: 'Breedte (cm)',
      length: 'Lengte (cm)',
      weight: 'Gewicht (g)',
      foodInstructions: 'Voedingsinstructies',
      storageInstructions: 'Bewaarinstructies',
      providerImage: 'Afbeelding',
      priceLockByType: {
        standard: 'Standaard',
        terminal: 'Terminal',
        preorder: 'Voorbestelling',
        inside: 'Prijs vergrendeld voor binnen',
        takeAway: 'Prijs vergrendeld voor afhaal',
        delivery: 'Prijs vergrendeld voor bezorging',
      },
      allergenes: {
        allergenes: 'Allergenen',
        cerealsWithGluten: 'Glutenbevattende granen',
        crustaceans: 'Schaaldieren en producten daarvan',
        eggs: 'Eieren en producten daarvan',
        fish: 'Vis en producten daarvan',
        peanuts: "Pinda's en producten daarvan",
        soya: 'Soja (bonen) en producten daarvan',
        milk: 'Melk en producten daarvan',
        nuts: 'Noten',
        celery: 'Selderij en producten daarvan',
        mustard: 'Mosterd en producten daarvan',
        sesame: 'Sesamzaad en producten daarvan',
        lupins: 'Lupine en producten daarvan',
        molluscs: 'Weekdieren en producten daarvan',
        corn: 'Maïs en producten daarvan',
        wheat: 'Tarwe en producten daarvan',
        rye: 'Bevat tarwe en producten daarvan',
        barley: 'Gerst en producten daarvan',
        oats: 'Haver en producten daarvan',
        spelt: 'Spelt en producten daarvan',
        khorasan: 'Khorasan tarwe en producten daarvan',
        walnuts: 'Walnoten en producten daarvan',
        pecanNuts: 'Pecannoten en producten daarvan',
        brazilNuts: 'Paranoten en producten daarvan',
        pistachioNuts: 'Pistachenoten en producten daarvan',
        macadamiaNuts: 'Macadamia noten en producten daarvan',
        almonds: 'Amandelen en producten daarvan',
        hazelnuts: 'Bevat hazelnoten en producten daarvan',
        cashews: 'Cashewnoten en producten daarvan',
        seeds: 'Zaden en producten daarvan',
        poppySeeds: 'Maanzaad en producten daarvan',
        sunflowerSeeds: 'Zonnebloempitten en producten daarvan',
        poultryMeat: 'Pluimveevlees en producten daarvan',
        beef: 'Rundvlees en producten daarvan',
        pigmeat: 'Varkensvlees en producten daarvan',
        yeast: 'Gistextract',
        sulfurDioxideAndSulphites: 'Bevat zwaveldioxide en sulfieten en producten daarvan',
        rye2: 'Bevat rogge en producten van rogge',
        gluten: 'Gluten',
      },
      additives: {
        additives: 'Toevoegingen',
        1: 'met kleurstof',
        2: 'met conserveermiddel',
        3: 'met antioxidant',
        4: 'met smaakversterker',
        5: 'bevat sulfieten',
        6: 'gezwart',
        7: 'met fosfaat',
        8: 'met melkeiwit (voor vleesproducten)',
        9: 'cafeïnehoudend',
        10: 'kinine',
        11: 'met zoetstof',
        12: 'gewast',
        13: 'nieuw',
        14: 'bevat Alcohol',
        15: 'bevat rogge en producten daarvan',
        16: 'met nitrietpEkelzout',
        17: 'zuurteregelaar',
        18: 'stabilisator',
        19: 'verzuringsmiddel',
      },
      traces: {
        traces: 'Sporen',
        sesame: 'kan sporen bevatten van sesam en producten daarvan',
        soy: 'kan sporen bevatten van soja en producten daarvan',
        peanuts: "kan sporen bevatten van pinda's en producten daarvan",
        wheat: 'kan sporen bevatten van tarwe en producten daarvan',
        lupins: 'kan sporen bevatten van lupine en producten daarvan',
        treeNuts: 'kan sporen bevatten van noten en producten daarvan',
        sulfurDioxide: 'kan sporen bevatten van zwaveldioxide en sulfieten en producten daarvan',
        fish: 'kan sporen bevatten van vis en producten daarvan',
        milk: 'kan sporen bevatten van melk en producten daarvan',
        eggs: 'kan sporen bevatten van eieren en producten daarvan',
        mustard: 'kan sporen bevatten van mosterd en producten daarvan',
        barley: 'kan sporen bevatten van gerst en producten daarvan',
      },
      nutrition: {
        portionInG: 'Portiegrootte (g)',
        portionInML: 'Portiegrootte (ml)',
        energyKcalPerPortion: 'Energie (kcal)',
        energyKcalPer100G: 'Energie (kcal/100g)',
        energyKcalPer100ML: 'Energie (kcal/100ml)',
        energyKjPerPortion: 'Energie (kj)',
        energyKjPer100G: 'Energie (kj/100g)',
        energyKjPer100ML: 'Energie (kj/100ml)',
        fatPerPortion: 'Vet (g)',
        fatPer100G: 'Vet (g/100g)',
        fatPer100ML: 'Vet (g/100ml)',
        saturatesPerPortion: 'Verzadigd vet (g)',
        saturatesPer100G: 'Verzadigd vet (g/100g)',
        saturatesPer100ML: 'Verzadigd vet (g/100ml)',
        carbohydratePerPortion: 'Koolhydraten (g)',
        carbohydratePer100G: 'Koolhydraten (g/100g)',
        carbohydratePer100ML: 'Koolhydraten (g/100ml)',
        sugarPerPortion: 'Suiker (g)',
        sugarPer100G: 'Suiker (g/100g)',
        sugarPer100ML: 'Suiker (g/100ml)',
        proteinPerPortion: 'Eiwit (g)',
        proteinPer100G: 'Eiwit (g/100g)',
        proteinPer100ML: 'Eiwit (g/100ml)',
        saltPerPortion: 'Zout (g)',
        saltPer100G: 'Zout (g/100g)',
        saltPer100ML: 'Zout (g/100ml)',
        highFat: 'Hoog Vetgehalte',
        highSugar: 'Hoog Suikergehalte',
      },
      features: {
        basic: 'Basis',
        features: 'Kenmerken',
        vegan: 'Veganistisch',
        vegetarian: 'Vegetarisch',
        glutenFree: 'Glutenvrij',
        noCarb: 'Koolhydraatvrij',
        alkaline: 'Alkalisch',
        lactoseFree: 'Lactosevrij',
        new: 'Nieuw',
        special: 'Speciaal',
        topSelling: 'Topverkoper',
        warm: 'Warm',
        cold: 'Koud',
        fish: 'Vis',
        chicken: 'Kip',
        beef: 'Rundvlees',
        pork: 'Varkensvlees',
        prepackaged: 'Voorverpakt',
        protein: 'Eiwitrijk',
        healthy: 'Gezond',
        menu: 'Menu',
        sticker: 'Sticker',
        spicyLevel: {
          label: 'Pittigheidsniveau',
          light: 'Pittig',
          medium: 'Zeer pittig',
          extra: 'Extra pittig',
        },
      },
    },
  },
  articleManager: {
    index: 'Artikelen & Opties Zichtbaarheid',
    overview: 'Overzicht',
    mainArticle: 'Hoofdartikelen',
    optionArticle: 'Optieartikelen',
    options: 'Opties',
    deactivateAll: 'Alles Deactiveren',
    activateAll: 'Alles Activeren',
    onlyOne: 'Nee, alleen deze',
    wolt: 'Wolt',
    uberEats: 'Uber-Eats',
    jet: 'Jet',
    filter: {
      category: 'Kies Categorie',
      status: 'Kies Status van Artikel',
      type: 'Artikel of Optieartikel',
      search: 'Zoeken',
      allStatus: 'Alle',
      active: 'Zichtbaar',
      notActive: 'Onzichtbaar',
      article: 'Artikel',
      options: 'Opties',
    },
    table: {
      visibility: 'Zichtbaarheid',
      name: 'Naam',
      category: 'Categorie',
      options: 'Opties',
      price: 'Prijs',
      optionGroup: 'Optiegroep',
      connectedArticles: 'Gekoppelde artikelen',
      description: 'Beschrijving',
      loadMore: 'Meer laden',
    },
    notification: {
      saved: 'Wijzigingen opgeslagen.',
      sameArticleNumber:
        'We hebben artikelen met hetzelfde artikelnummer gevonden. Wilt u ze allemaal activeren/deactiveren (afhankelijk van de actie), of alleen deze?',
    },
  },
  translation: {
    start: 'Vertaling gestart. Dit kan tot 10 minuten duren',
    index: 'Vertaling',
    overview: 'Overzicht',
    translate: 'vertalen',
    languages: {
      en: 'Engels',
      de: 'Duits',
      fr: 'Frans',
      nl: 'Nederlands',
      it: 'Italiaans',
      pl: 'Pools',
      es: 'Spaans',
      zh: 'Chinees',
      ru: 'Russisch',
      tr: 'Turks',
      da: 'Deens',
      ja: 'Japans',
      is: 'IJslands',
      pt: 'Portugees',
      cz: 'Tsjechisch',
      ar: 'Arabisch',
      el: 'Grieks',
      ko: 'Koreaans',
      th: 'Thais',
      vi: 'Vietnamees',
      hi: 'Hindi',
      ur: 'Urdu',
      tl: 'Tagalog',
      id: 'Indonesisch',
      no: 'Noors',
      sv: 'Zweeds',
      lt: 'Litouws',
      fi: 'Fins',
    },
  },
  payment: {
    index: 'Betalingen',
    overview: 'Overzicht',
    refundArticle: 'Artikel Terugbetalen',
    refundArticleSmoothr: 'Artikel Terugbetalen Alleen Smoothr',
    refundOrder: 'Bestelling Terugbetalen',
    refundOrderSmoothr: 'Bestelling Terugbetalen Alleen Smoothr',
    refundQuestion: 'Weet u zeker dat u wilt terugbetalen? Deze actie kan niet ongedaan worden gemaakt.',
    refunded: 'Maakt deel uit van een terugbetaling',
    order: 'Bestelling',
    refund: 'Terugbetalingen beschikbaar',
    searchCode: 'Zoeken op bestelcode...',
    searchTransactionId: 'Zoeken op transactie ID...',
    sendInvoice: 'Factuur verzenden',
    showLogs: 'Logs tonen',
    hideLogs: 'Logs verbergen',
    logs: {
      logs: 'Logs',
      noLogs: 'Er zijn geen logs beschikbaar voor deze betaling.',
      payment: 'Betaling',
      provider: 'Provider',
      venue: 'Venue',
      messageType: 'Berichttype',
      httpMethod: 'HTTP-methode',
      httpStatusCode: 'HTTP-statuscode',
      url: 'URL',
      endpoint: 'Eindpunt',
      result: 'Resultaat',
      createdAt: 'Aangemaakt op',
      updatedAt: 'Bijgewerkt op',
      expiresAt: 'Verloopt op',
    },
    notification: {
      invoiceSent: 'De factuur is succesvol verzonden.',
    },
    table: {
      sum: 'Som',
      tip: 'Fooi',
      status: 'Status',
      hasRefunds: 'Terugbetalingen',
      codes: 'Codes',
      method: 'Betaalmethode',
      createdAt: 'Datum',
      id: 'Id',
      merchantReference: 'Handelaarsreferentie',
      checkoutId: 'PSP-Referentie',
      subMethod: 'Sub Methode',
      orderedArticles: 'Bestelde Artikelen',
      checkoutOrderedArticles: 'Bestelde Artikelen bij Afrekenen',
    },
    form: {
      quantity: 'Aantal',
      email: 'E-Mail',
    },
  },
  option: {
    index: 'Opties Beheren',
    create: 'Nieuwe Optie Aanmaken',
    edit: 'Optie Bewerken',
    add: 'Optie Toevoegen',
    copy: 'Optie Kopiëren',
    unlinkedOptions: 'Opties niet gekoppeld aan artikelen',
    empty:
      'Het lijkt erop dat u nog geen opties heeft toegevoegd. Maak uw eerste optiegroep aan om nog betere en aanpasbare artikelen te maken.',
    overview: 'Overzicht',
    tabs: {
      general: 'Algemeen',
      articles: 'Artikelen',
      features: 'Kenmerken',
      availableHours: 'Beschikbare Uren',
      compound: {
        features: 'Kenmerken',
        new: 'Nieuw',
        special: 'Speciaal',
        topSelling: 'Topverkoper',
      },
    },
    articles: {
      table: {
        name: 'Naam',
        description: 'Beschrijving',
        price: 'Prijs',
        sortOrder: 'Sortering',
        internalNote: 'Interne Notitie',
        internalName: 'Interne Naam',
        assets: 'Afbeeldingen',
        active: 'Actief',
        visible: 'Zichtbaar',
        number: 'Nummer',
      },
      addTitle: 'Artikel toevoegen',
      editTitle: 'Artikel bewerken',
    },
    table: {
      name: 'Naam',
      description: 'Beschrijving',
      requiredAmount: 'Vereist Aantal',
      limit: 'Limiet',
      hasMultiple: 'Heeft Meerdere',
      sortOrder: 'Sortering',
      visible: 'Zichtbaar',
      article: 'Artikel',
    },
    form: {
      name: 'Naam',
      description: 'Beschrijving',
      shortDescription: 'Korte Beschrijving',
      image: 'Afbeelding',
      externalId: 'Externe ID',
      limit: 'Limiet',
      active: 'Actief',
      visible: 'Zichtbaar',
      virtual: 'Virtueel',
      sort: 'Sortering',
      printerSort: 'Printer Sortering',
      requiredAmount: 'Vereist Aantal',
      hasMultiple: 'Meerdere',
      displayIdentifiers: 'Weergave Identificaties',
      displayMode: 'Weergavemodus',
      displayModeSot: 'Weergavemodus SOT',
      displayModeMobile: 'Weergavemodus Mobiel',
      tags: 'Tags',
      printGroups: 'Print Groepen',
    },
    deleteHeader: 'Opties Verwijderen',
    deleteInfo: 'Weet u zeker dat u deze opties wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    deleteSelected: 'Selectie Verwijderen',
  },
  category: {
    index: 'Categorieën Beheren',
    create: 'Nieuwe Categorie Aanmaken',
    edit: 'Categorie Bewerken',
    add: 'Categorie Toevoegen',
    overview: 'Overzicht',
    availableHours: 'Beschikbare Uren',
    table: {
      name: 'Naam',
      sort: 'Sortering',
      mainCategory: 'Hoofdcategorie',
      visible: 'Zichtbaar',
    },
    form: {
      name: 'Naam',
      description: 'Beschrijving',
      mainCategory: 'Hoofdcategorie',
      sort: 'Sortering',
      displayMode: 'Weergavemodus',
      mainRecommendations: 'Hoofd Aanbevelingen',
      displayIdentifiers: 'Weergave Identificaties',
      visible: 'Zichtbaar',
      image: 'Afbeelding',
      icon: 'Pictogram',
    },
    tabs: {
      features: 'Kenmerken',
      new: 'Nieuw',
      special: 'Speciaal',
      topSelling: 'Topverkoper',
    },
  },
  subscriptionCategories: {
    index: 'Abonnementscategorieën Beheren',
    create: 'Nieuwe Abonnementscategorie Aanmaken',
    edit: 'Abonnementscategorie Bewerken',
    add: 'Abonnementscategorie Toevoegen',
    overview: 'Overzicht',
    table: {
      name: 'Naam',
    },
    form: {
      name: 'Naam',
      description: 'Beschrijving',
      image: 'Afbeelding',
      subscriptions: 'Abonnementen',
      venues: 'Locaties',
      canCombine: 'Combineren',
      isActive: 'Actief',
    },
  },
  subscription: {
    index: 'Abonnementen Beheren',
    create: 'Nieuw Abonnement Aanmaken',
    edit: 'Abonnement Bewerken',
    add: 'Abonnement Toevoegen',
    overview: 'Overzicht',
    table: {
      name: 'Naam',
    },
    form: {
      name: 'Naam',
      description: 'Beschrijving',
      image: 'Afbeelding',
      useMasterFoodcard: 'Gebruik Master Foodcard',
      maxPricePerOrder: 'Max. Prijs per Bestelling',
      maxPricePerArticle: 'Max. Prijs per Artikel',
      maxArticlesPerOrder: 'Max. Artikelen per Bestelling',
      maxOrdersPerDay: 'Max. Bestellingen per Dag',
      minimumOrderOffset: 'Minimale Besteloffset',
      isActive: 'Actief',
      automaticallyRenew: 'Automatisch Vernieuwen',
      tax: 'BTW',
      articles: 'Artikelen',
      venues: 'Locaties',
      linkedCustomerGroup: 'Gekoppelde Klantengroep',
      price: 'Prijs',
      factor: 'Factor',
      unit: 'Eenheid',
      default: 'Standaard',
    },
  },
  membership: {
    index: 'Lidmaatschappen Beheren',
    create: 'Nieuw Lidmaatschap Aanmaken',
    edit: 'Lidmaatschap Bewerken',
    add: 'Lidmaatschap Toevoegen',
    overview: 'Overzicht',
    table: {
      name: 'Naam',
    },
    form: {
      name: 'Naam',
      description: 'Beschrijving',
      image: 'Afbeelding',
      multiplier: 'Vermenigvuldiger',
      neededPoints: 'Benodigde Punten',
      piggyId: 'Piggy Id',
      customerGroup: 'Klantengroep',
    },
    tier: {
      membershiptier1: 'lidmaatschapniveau1',
      membershiptier2: 'lidmaatschapniveau2',
      membershiptier3: 'lidmaatschapniveau3',
      membershiptier4: 'lidmaatschapniveau4',
      membershiptier5: 'lidmaatschapniveau5',
    },
  },
  table: {
    index: 'Tafels Beheren',
    create: 'Nieuwe Tafel Aanmaken',
    exportQrs: 'QR-Codes Exporteren',
    assignLightspeedWaiter: 'Lightspeed ober toewijzen',
    toggleTablesByRange: 'Tafels per Bereik In-/Uitschakelen',
    toggleTablesByTag: 'Tafels per Tag In-/Uitschakelen',
    edit: 'Tafel Bewerken',
    add: 'Tafel Toevoegen',
    overview: 'Overzicht',
    table: {
      number: 'Nummer',
      description: 'Beschrijving',
      active: 'Actief',
      tags: 'Tags',
      qr: 'QR-Code',
      sanifairDeviceId: 'Sanifair Apparaat-ID',
    },
    form: {
      number: 'Nummer',
      description: 'Beschrijving',
      sanifairDeviceId: 'Sanifair Apparaat-ID',
      lightspeedWaiterId: 'Lightspeed-Ober',
      simphonyRvcRef: 'Simphony RVC Referentie',
      pendingCashPaymentEnabled: 'Openstaande contante betalingen activeren',
      openOrdersEnabled: 'Openstaande bestellingen activeren',
      viewStaff: 'Personeel Bekijken',
      select: 'Selecteren',
      isActive: 'Actief',
      start: 'Start',
      end: 'Einde',
      tag: 'Tag',
    },
    notification: {
      assignLightspeedWaiterSuccess: 'Lightspeed ober is succesvol toegewezen aan de geselecteerde tafels.',
      assignLightspeedWaiterError:
        'Er is een fout opgetreden bij het toewijzen van de Lightspeed ober aan de geselecteerde tafels.',
      massActiveSuccess: 'Tafels zijn succesvol bijgewerkt.',
      massActiveError: 'Er is een fout opgetreden bij het bijwerken van de tafels.',
    },
  },
  venue: {
    index: 'Locaties Beheren',
    create: 'Nieuwe Locatie Aanmaken',
    copyFoodcard: 'Foodcard kopiëren',
    editMasterId: 'Master-ID Bewerken',
    copyArticles: 'Artikelen kopiëren',
    importHellotess: 'Foodcard importeren van Hellotess',
    importGastrofix: 'Foodcard importeren van Gastrofix',
    importDeliverect: 'Foodcard importeren van Deliverect',
    importSimphony: 'Foodcard importeren van Simphony',
    generalImport: 'Algemene Foodcard Import',
    panic: 'Panic',
    ppConnected: 'PayPal Account Status',
    ppConnectedSuccess: 'PayPal-account succesvol verbonden.',
    ppConnectedError: 'PayPal-account is niet verbonden of is mislukt.',
    lightspeedAuthorize: 'Lightspeed autoriseren',
    lightspeedAuthorized: 'Lightspeed succesvol geautoriseerd',
    lightspeedNotAuthorized: 'Lightspeed is niet geautoriseerd',
    generateSlugAuto: 'Slug automatisch genereren',
    standardSlots: 'Standaard Slots',
    terminalSlots: 'Terminal Slots',
    preorderSlots: 'Voorbestel Slots',
    createSimple: 'Nieuwe Locatie Aanmaken',
    overview: 'Overzicht',
    add: 'Locatie Toevoegen',
    sync: 'Locatie Synchroniseren',
    tooltipCannotSync: 'Synchronisatie is al bezig. Wacht of neem contact op met een beheerder',
    liftSyncLock: 'Sync-vergrendeling opheffen',
    refresh: 'Vernieuwen',
    copy: 'Locatie kopiëren',
    copyVenueOnly: 'Alleen locatie kopiëren',
    deleteFoodcard: 'Foodcard Verwijderen',
    copyConfirm: 'Weet u zeker dat u een duplicaat van de locatie wilt maken?',
    copySuccess: 'Locatie is gekopieerd',
    archive: 'Archiveren',
    testOrder: 'Testbestelling Verzenden',
    registerPayPal: 'PayPal-account Verbinden',
    checkPayPalOnboarding: 'PayPal Accountstatus Controleren',
    deliveryFees: 'Bezorgkosten',
    deliveryFeesRadius: 'Bezorgkosten per Straal',
    deliveryFeesPostalCode: 'Bezorgkosten per Postcode',
    deliveryFeesAreas: 'Bezorgkosten per Gebied',
    edit: 'Locatie Bewerken',
    parkCollect: 'Park & Collect',
    migrate: 'Locatie Migreren',
    stations: 'Stations',
    migration: 'Migratie',
    eodReport: 'EOD rapport',
    customerSupportMail: 'Klantenservice',
    generateWebAppSlug: 'Web App Slug Genereren',
    panicInfo: 'Informatie: Panic voor de Locatie {venue} is geactiveerd tot {panicEndAt} uur. {reason}.',
    snoozing: 'Snoozing Opties',
    offsetReset: 'Offset Reset Tijd',
    milesAndMore: 'Miles & More',
    kost: 'KOST',
    ncr: 'NCR',
    revel: 'Revel',
    arcavis: 'Arcavis',
    erpVoucher: 'ERP Voucher',
    tips: 'Fooien',
    notification: {
      testOrderSuccess: 'De testbestelling was succesvol.',
      testOrderError:
        'De testbestelling is mislukt. Controleer uw instellingen of neem contact op met een beheerder als u nog steeds problemen ondervindt.',
      sendInvoiceSuccess: 'Factuur is succesvol verzonden.',
      createCreditNoteSuccess: 'Creditnota is succesvol aangemaakt.',
      registerPayPalError: 'Kon PayPal niet autoriseren.',
      checkPayPalOnboardingError: 'Kon de status van de PayPal onboarding niet controleren.',
      checkPayPalOnboardingSuccess: 'Vernieuw de pagina om de wijzigingen te zien.',
      sendInvoiceError: 'Verzenden van factuur mislukt.',
      createCreditNoteError: 'Aanmaken van creditnota mislukt.',
      copyOptionSuccess: 'Optie is gekopieerd',
      copyOptionError: 'Optie kopiëren mislukt. Controleer de logs.',
      authorizePayPal:
        'Om te autoriseren, vult u de velden Merchant ID en E-mail in bij PayPal Credentials en slaat u op.',
      copyRunning: 'Het kopiëren van de locatie is gestart en wordt uitgevoerd.',
      copyError: 'Locatie kopiëren mislukt. Controleer de logs.',
      webAppSlug:
        'Weet u zeker dat u het Web App Slug-veld wilt genereren? In dit geval wordt het voor alle locaties gedaan.',
      masterId: 'Master-ID',
      deleteSuccess: 'Foodcard succesvol verwijderd!',
      refreshSuccess: 'Locatie vernieuwen succesvol voltooid.',
      refreshError: 'Er is een fout opgetreden bij het vernieuwen van de locatie.',
      sepa: {
        createSuccess: 'Nieuwe SEPA-mandaatregistratielink is succesvol aangemaakt',
        createError: 'Kon geen nieuwe SEPA-mandaatregistratielink aanmaken',
        paySuccess: 'Nieuwe SEPA-betaling is succesvol aangemaakt',
        payError: 'Kon geen nieuwe SEPA-betaling aanmaken',
      },
    },
    filter: {
      publishedStatus: 'Publicatiestatus',
      published: 'Gepubliceerd',
      unpublished: 'Niet Gepubliceerd',
      verifiedStatus: 'Verificatiestatus',
      syncStatus: 'Synchronisatiestatus',
      idle: 'Niet aan het synchroniseren',
      sync: 'Synchroniseren',
      verified: 'Geverifieerd',
      customerGroup: 'Klantengroep',
      unverified: 'Niet Geverifieerd',
      deletedAt: 'Archief Bekijken',
      isServiceActivatedStatus: 'Servicestatus',
      deliveryEnabledStatus: 'Bezorging Ingeschakeld Status',
      panicModeStatus: 'Panic Status',
      activated: 'Geactiveerd',
      notActivated: 'Niet Geactiveerd',
      enabled: 'Ingeschakeld',
      notEnabled: 'Niet Ingeschakeld',
      panicActive: 'Actief',
      panicInactive: 'Inactief',
    },
    station: {
      placeholder: 'Typ stationsnaam',
      deleteStation: 'Weet u zeker dat u het station wilt verwijderen?',
      addStation: '+ Station toevoegen',
    },
    confirmation: {
      verify: {
        title: 'Locatiebevestiging',
        text: 'Door op de onderstaande knop te klikken, gaat u ermee akkoord dat alle artikelen, prijzen en locatie-instellingen correct zijn. Bovendien hebt u de algemene voorwaarden, privacyverklaring en de disclaimer geüpload. Voor eventuele onjuiste instellingen bent u aansprakelijk.',
        action: 'Locatie Verifiëren',
      },
      publish: {
        title: 'Publicatiebevestiging',
        text: 'Door op de onderstaande knop te klikken, gaat u ermee akkoord dat alle artikelen, prijzen en locatie-instellingen correct zijn. Voor eventuele onjuiste instellingen bent u aansprakelijk.',
        action: 'Locatie Publiceren',
      },
      deleteFoodcard: {
        title: 'Weet u zeker dat u de volledige foodcard wilt verwijderen?',
        text: 'U verwijdert alle categorieën, artikelen, optiegroepen, optieartikelen en tags met deze actie.<br/><br/>Deze actie kan niet ongedaan worden gemaakt.',
      },
    },
    verify: 'Verifiëren',
    publish: 'Publiceren',
    credentials: 'Inloggegevens',
    payment: 'Betaling',
    order: 'Bestelling',
    preorder: 'Voorbestelling',
    slotting: 'Slot Instellingen',
    documents: 'Documenten',
    invoices: {
      createCreditNote: 'Creditnota Aanmaken',
      createCreditNoteNet: 'Creditnota Aanmaken (Netto Waarde)',
      send: 'Factuur Verzenden',
      transactions: 'Transacties',
      balance: 'Saldo',
      type: 'Factuurtype',
      refOrNote: 'Factuurreferentie / Notitie',
      createdAt: 'Gemaakt Op',
      amount: 'Bedrag',
      setupFee99: 'Opstartkosten (99€)',
      setupFee49: 'Opstartkosten (49€)',
      premiumPrinterPackage: 'Premium Printerpakket',
      printerTablet: 'Tablet met geïntegreerde printer (319,00 + 8,00 €)',
      printerTablet200: 'Tablet met geïntegreerde printer (200€ + 8€)',
      printerTablet230: 'Tablet met geïntegreerde printer (230€ + 8€)',
      provision: 'Provision',
      creditNoteNet: 'Creditnota (Netto Waarde)',
      status: 'Status',
    },
    productCombos: {
      addCombo: 'Combo Toevoegen',
      addArticle: 'Artikel Toevoegen',
      addColumn: 'Kolom Toevoegen',
      deleteColumn: 'Kolom Verwijderen',
      result: 'Selecteer resultaatartikel',
      column: 'Selecteer artikel',
    },
    ci: 'Checkout Integratie',
    cip: 'Checkout Integratie Eigenschappen',
    general: 'Algemeen',
    details: 'Details',
    contact: 'Contact',
    whiteLabel: 'whiteLabel',
    invoiceReceiver: 'Factuuradres',
    address: 'Adres',
    settings: 'Instellingen',
    sizeSettings: 'Maat Instellingen',
    orderOffsets: 'Besteloffsets',
    preorderOffsets: 'Voorbesteloffsets',
    fireTimeOffsets: 'Firetime Offsets',
    uberDelivery: 'Uber Bezorging',
    miscellaneous: 'Diversen',
    preorderPayment: 'Voorbestel Betaling',
    deliveryPayment: 'Voorbestel Bezorgbetaling',
    sepaCredentials: 'SEPA Inloggegevens',
    ccCredentials: 'Creditcard Inloggegevens',
    ppCredentials: 'PayPal Inloggegevens',
    sbCredentials: 'SofortBanking Inloggegevens',
    apCredentials: 'ApplePay Inloggegevens',
    gpCredentials: 'GooglePay Inloggegevens',
    walleeCredentials: 'Wallee Inloggegevens',
    worldlineCredentials: 'Worldline Inloggegevens',
    datatransCredentials: 'DataTrans Inloggegevens',
    adyenCredentials: 'Adyen Inloggegevens',
    walleePaymentConfs: 'Wallee Betaling',
    neptingCredentials: 'Nepting Inloggegevens',
    eServiceCredentials: 'eService Inloggegevens',
    openingHours: 'Openingstijden',
    specialOpeningHours: 'Speciale Openingstijden',
    deliveryHours: 'Bezorgtijden',
    specialDeliveryHours: 'Speciale Bezorgtijden',
    salesforce: 'Salesforce',
    salesforcePromotions: 'Salesforce Promoties',
    sanifair: 'Sanifair',
    delfi: 'Delfi',
    loyalty: 'Loyaliteit',
    boardingPass: 'Boarding Pass',
    datev: 'Datev',
    storeLink: 'Winkel link',
    viewCounters: 'Tellers Bekijken',
    voucherify: 'Voucherify',
    grubtech: 'GrubTech',
    finances: 'Financiën',
    nutrition: 'Voedingswaarden',
    panicModeHistory: {
      startAt: 'Start Op',
      endAt: 'Einde Op',
      reason: 'Reden',
    },
    locTypes: {
      bar: 'Bar',
      club: 'Club',
      restaurant: 'Restaurant',
      db: 'Deutsche Bahn',
      cinema: 'Bioscoop',
      other: 'Anders',
    },
    tabs: {
      general: 'Algemeen',
      payment: 'Betaling',
      terminal: 'Terminal',
      preorder: 'Voorbestelling',
      ci: 'CheckoutIntegratie',
      orderOffsets: 'Besteloffsets',
      order: 'Bestelling',
      slotting: 'Slotting',
      cateringHours: 'Catering Uren',
      documents: 'Documenten',
      openingHours: 'Openingstijden',
      productCombos: 'Productcombinaties',
      deliveryHours: 'Bezorgtijden',
      deliveryProviders: 'Bezorgdiensten',
      externalDeliveryService: 'Externe Bezorgdienst',
      orderProviders: 'Besteldiensten',
      invoices: 'Facturen',
      sanifair: 'Sanifair',
      salesforce: 'Salesforce',
      delfi: 'Delfi',
      loyalty: 'Loyaliteit',
      boardingPass: 'Boarding Pass',
      datev: 'Datev',
      milesAndMore: 'Miles & More',
      erpVoucher: 'ERP Voucher',
      tips: 'Fooien',
      voucherify: 'Voucherify',
      grubtech: 'GrubTech',
      finances: 'Financiën',
      nutrition: 'Voedingswaarden',
    },
    table: {
      name: 'Naam',
      shortId: 'Korte-ID',
      sort: 'Sortering',
      email: 'E-Mail',
      street: 'Straat',
      number: 'Nummer',
      city: 'Stad',
      legalForm: 'Rechtsvorm',
      locType: 'Type',
      vatNumber: 'BTW-ID',
      vatNumberGermany: 'Duits Belastingnummer',
      isServiceActivated: 'Service Geactiveerd',
      deliveryEnabled: 'Bezorging Ingeschakeld',
      customerGroup: 'Klantengroep',
      checkoutIntegration: 'Checkout Integratie',
      piggyLoyaltyEnabled: 'Loyaliteit',
      isPublished: 'Gepubliceerd',
      webAppSlug: 'Web App Slug',
      masterId: 'Master-ID',
      externalOrderProviderStatus: 'Winkelstatus (Wolt/Uber Eats)',
      preorderTakeAway: 'Voorbestel Afhaal',
      panicModeHistory: 'Panic Geschiedenis',
      cases: 'Cases',
    },
    form: {
      secondaryCodeEnabled: 'Secundaire Code Ingeschakeld',
      standardOrderOffsets: 'Standaard Besteloffsets',
      terminalInsideOffsets: 'Terminal Binnen Offsets',
      terminalTakeAwayOffsets: 'Terminal Afhaal Offsets',
      preorderInsideOffsets: 'Voorbestel Binnen Offsets',
      preorderTakeAwayOffsets: 'Voorbestel Afhaal Offsets',
      preorderDeliveryOffsets: 'Voorbestel Bezorg Offsets',
      cateringTakeAway: 'Catering Afhaal Toestaan',
      cateringDelivery: 'Catering Bezorging Toestaan',
      cateringTakeAwayHours: 'Catering Afhaal Uren',
      cateringDeliveryHours: 'Catering Bezorg Uren',
      cateringDeliveryOffsets: 'Catering Bezorg Offsets',
      cateringTakeAwayOffsets: 'Catering Afhaal Offsets',
      couponsEnabled: 'Couponing',
      cateringSlots: 'Catering Slots',
      parkCollectionLocationText: 'Locatietekst',
      venue: 'Locatie',
      masterId: 'Master-ID',
      sort: 'Sortering',
      sourceVenue: 'Bron-Locatie',
      targetVenue: 'Doel-Locatie',
      sendEodReport: 'EOD-rapport verzenden naar e-mails',
      sendEodReportEmails: 'Lijst met e-mails om rapporten naar te verzenden',
      source: 'Bron',
      image: 'Afbeelding',
      masterType: 'Besteltype',
      uberCustomerId: 'Uber Klant Id',
      uberDeliveryEnabled: 'Uber Bezorging Ingeschakeld',
      uberBatchSize: 'Batchgrootte',
      externalDeliveryService: {
        name: 'Naam',
        link: 'Link',
        icon: 'Pictogram',
      },
      name: 'Naam',
      newName: 'Nieuwe Naam',
      asSlave: 'Maak de locatie aan als slave van de geselecteerde locatie',
      sapNumber: 'SAP Nummer',
      externalLocationId: 'Externe Locatie Id',
      loginRequired: 'Inloggen Vereist',
      restaurantToken: 'Smoothr Restaurant Token',
      standardSlot: 'Max. Standaard Bestellingen per interval',
      takeAwaySlot: 'Max. Afhaal Bestellingen per interval',
      calculateDays: 'Aantal dagen om slots te berekenen',
      insideSlot: 'Max. Binnen Bestellingen per interval',
      deliverySlot: 'Max. Bezorg Bestellingen per interval',
      properties: 'Eigenschappen',
      syncType: 'Sync Type',
      fullName: 'Bedrijfsnaam',
      currency: 'Valuta',
      deliveryPostalCodes: 'Bezorg Postcodes',
      deliveryPostalCodesHint: 'Voer een postcode in met een bijbehorende stad (bijv. 50679 Keulen)',
      country: 'Land',
      locType: 'Locatietype',
      deliveryFee: 'Bezorgkosten in {currency} (indien niet anders gespecificeerd)',
      deliveryByRadius: 'Gebruik Bezorgstraal (Anders per Postcode)',
      deliveryByAreas: 'Gebruik Bezorggebieden (Anders per Postcode)',
      provisionRate: 'Provision Tarief',
      bcsig: 'BCSIG',
      supplier: 'Leverancier',
      webAppUrl: 'WebApp Url',
      panicEndAt: 'Panic (indien actief, zijn voorbestellingen niet mogelijk)',
      provisionFixedRate: 'Vast Provision Tarief',
      readableId: 'Korte ID',
      migrationType: 'Migratie Type',
      deliveryRadius: 'Bezorgstraal',
      deliveryRadiusMax: 'Bezorgstraal (max)',
      isPublished: 'Gepubliceerd',
      venues: 'Locaties',
      deliveryHours: 'Bezorgtijden',
      sanifair: 'Sanifair Instellingen',
      active: 'Actief',
      virtualOrders: 'Virtuele Bestellingen Toestaan',
      stock: 'Voorraad',
      movDelivery: 'Minimale Bestelwaarde -- Bezorging (EUR)',
      checkoutIntegration: 'Checkout Integratie',
      printerIntegration: 'Printer Integratie',
      readyOffset: 'Voorbereidingsoffset',
      readyOffsetDelivery: 'Voorbereidingsoffset Bezorging',
      interval: 'Intervalgrootte',
      reserved: 'Gereserveerde Bestellingen',
      max: 'Max. Bestellingen In Interval (verouderd)',
      notPickedOffset: 'Niet opgehaalde offset',
      isServiceActivated: 'Servicestatus (indien niet geactiveerd, is bestellen uitgeschakeld)',
      isCallingSystemEnabled: 'Oproepsysteem',
      inventoryEnabled: 'Inventaris Ingeschakeld',
      milesAndMoreEnabled: 'Miles & More Ingeschakeld',
      erpVoucherEnabled: 'ERP Voucher Ingeschakeld',
      legalForm: 'Rechtsvorm',
      email: 'E-Mail',
      orderEmail: 'Bestel E-Mail',
      storeEmail: 'Winkel E-Mail',
      web: 'Website',
      standardOrders: 'Standaard Bestellingen Toestaan',
      preorderTakeAway: 'Voorbestel Afhaal Toestaan',
      preorderParkCollect: 'Park & Collect Toestaan',
      preorderFoodspot: 'Foodspot Toestaan',
      preorderIn: 'Voorbestel In Huis Toestaan',
      preorderDelivery: 'Bezorging Toestaan',
      autoAccept: 'Auto Accepteer in',
      autoAcceptTerminal: 'Auto Accepteer Terminalbestelling in',
      checkoutIn: 'Afrekenen in',
      printIn: 'Afdrukken in',
      autoReset: 'Auto Reset in',
      orderTimeout: 'Besteltime-out',
      orderTimeoutEnabled: 'Besteltime-out Activeren',
      phone: 'Telefoon',
      fax: 'Fax',
      city: 'Stad',
      area: 'Dichtstbijzijnde Stad',
      street: 'Straat',
      streetAddress: 'Straatadres',
      number: 'Nummer',
      company: 'Bedrijf',
      postalCode: 'Postcode',
      federalState: 'Deelstaat',
      deliveryAddress: 'Bezorgadres',
      orderPrinterTabletPackageInfo:
        'Bestel een tablet met geïntegreerde printer voor {price}€. Zonder printer ontvangt u nieuwe bestellingen alleen via e-mail.',
      orderPremiumPackage: 'Printer Bestellen',
      timezone: 'Tijdzone',
      googlePlacesId: 'Google Places ID',
      customerGroup: 'Klantengroep',
      sendProvisionReportPeriod: 'Provision Rapport Verzenden',
      lastInvoiceNumber: 'Laatste factuurnummer',
      sendProvisionReportPeriodNonInvoiceable: 'Provision Rapport Verzenden (zonder factuurnummer)',
      vatNumber: 'BTW-ID',
      vatNumberQuestion: 'USt-IdNr. gebruiken?',
      vatNumberGermany: 'Duits Belastingnummer (bijv. 12/345/67890)',
      vatNumberGermanyQuestion: 'Geen USt-IdNr.?',
      mov: 'MOV',
      from: 'Van',
      fee: 'Kosten',
      deliveryArea: 'Bezorggebied',
      secureCode: 'Beveiligingscode',
      selfCertification: 'Zelfcertificering',
      reviewHyperlink: 'Review hyperlink',
      pdfUpload: 'PDF-Bestand Uploaden',
      kmlUpload: 'KML-Bestand Uploaden',
      insertLink: 'Link Invoegen',
      nutritionTable: 'Voedingstabel',
      nutritionInfo: 'Voedingsinformatie',
      gpsManualInput: 'Handmatige Invoer (GPS-coördinaten)',
      gpsCorrect: 'GPS-coördinaten OK?',
      latitude: 'Breedtegraad',
      longitude: 'Lengtegraad',
      adyenEnabled: 'Adyen Ingeschakeld',
      adyenPaypalEnabled: 'Adyen PayPal Ingeschakeld',
      merchantAccount: 'Handelaarsaccount',
      urlPrefix: 'URL Voorvoegsel',
      clientKey: 'Clientsleutel',
      property: 'Eigendom',
      paymentEnabled: 'Betaling Ingeschakeld',
      sepaEnabled: 'SEPA Ingeschakeld',
      sbEnabled: 'SofortBanking Ingeschakeld',
      gpEnabled: 'GooglePay Ingeschakeld',
      apEnabled: 'ApplePay Ingeschakeld',
      ppEnabled: 'PayPal Ingeschakeld',
      vrPaymentEnabled: 'VR Ingeschakeld',
      rekaEnabled: 'Reka Ingeschakeld',
      twintEnabled: 'Twint Ingeschakeld',
      walleeEnabled: 'Wallee Ingeschakeld',
      tacEnabled: 'Tac Ingeschakeld',
      comoLoyaltyEnabled: 'Como Loyalty Ingeschakeld',
      tipRefundEnabled: 'Fooi Terugbetalen Ingeschakeld',
      alipayEnabled: 'Alipay Ingeschakeld',
      wcEnabled: 'WeChat Pay Ingeschakeld',
      bcEnabled: 'Boncard Ingeschakeld',
      lchEnabled: 'Luncheck Ingeschakeld',
      cwlEnabled: 'Worldline Ingeschakeld',
      ccvEnabled: 'CCV Ingeschakeld',
      zeroPaymentEnabled: 'Zero Payment Ingeschakeld',
      woltPaymentEnabled: 'Wolt Betaling Ingeschakeld',
      uberEatsPaymentEnabled: 'Uber-Eats-Betaling Ingeschakeld',
      jetPaymentEnabled: 'JET-Betaling Ingeschakeld',
      deliverooPaymentEnabled: 'Deliveroo-Betaling Ingeschakeld',
      kostCardPaymentEnabled: 'KOST-Kaart-Betaling Ingeschakeld',
      ctCreditCardPaymentEnabled: 'Computop Creditcard Ingeschakeld',
      bankTransferPaymentEnabled: 'Bankoverschrijving Ingeschakeld',
      dataTransEnabled: 'Datatrans Ingeschakeld',
      piggyGiftCardEnabled: 'Piggy Cadeaukaart Ingeschakeld',
      piggyPrepaidBalanceEnabled: 'Piggy Prepaid Saldo Ingeschakeld',
      sapCCOEnabled: 'SAP CCO Ingeschakeld',
      worldlineEnabled: 'Worldline Ingeschakeld',
      wlApplePayEnabled: 'Worldline Apple Pay Ingeschakeld',
      wlApplePayMobileEnabled: 'Worldline Apple Pay Mobiel Ingeschakeld',
      wlGooglePayEnabled: 'Worldline Google Pay Ingeschakeld',
      wlGooglePayMobileEnabled: 'Worldline Google Pay Mobiel Ingeschakeld',
      wlCardEnabled: 'Worldline Kaart Ingeschakeld',
      wlCardMobileEnabled: 'Worldline Kaart Mobiel Ingeschakeld',
      pfEnabled: 'PostFinance E-Finance Ingeschakeld',
      pfcEnabled: 'PostFinance Card Ingeschakeld',
      ppV2Enabled: 'PayPal V2 Ingeschakeld',
      ppFullIntegrationEnabled: 'PayPal Volledige Integratie Ingeschakeld',
      ccEnabled: 'Creditcard Ingeschakeld',
      posEnabled: 'POS Ingeschakeld',
      cashEnabled: 'Contant Ingeschakeld',
      neptingEnabled: 'Nepting Ingeschakeld',
      eServiceEnabled: 'eService Ingeschakeld',
      vippsEnabled: 'Vipps Ingeschakeld',
      swishEnabled: 'Swish Ingeschakeld',
      mobilePayEnabled: 'MobilePay Ingeschakeld',
      dankortEnabled: 'Dankort Ingeschakeld',
      maxxvendEnabled: 'MAXXvend Ingeschakeld',
      amexEnabled: 'Amex Ingeschakeld',
      secretKey: 'Geheime Sleutel',
      merchantName: 'Handelaarsnaam',
      creditorId: 'Crediteuren-ID',
      merchantId: 'Handelaars-ID',
      merchantIdPP: 'Handelaars-ID',
      userId: 'Gebruikers-ID',
      spaceId: 'Ruimte-ID',
      userKey: 'Gebruikerssleutel',
      reka: 'Reka',
      twint: 'Twint',
      boncard: 'Boncard',
      luncheck: 'Luncheck',
      postfinance: 'Postfinance',
      postfinanceCard: 'Postfinance Card',
      wechat: 'Wechat',
      alipay: 'Alipay',
      worldline: 'Worldline',
      ppEmail: 'Account E-Mail',
      ppEmailConfirmed: 'PayPal E-mail is Bevestigd',
      ppEmailNotConfirmed: 'PayPal E-mail is niet Bevestigd',
      ppPaymentsReceivable: 'PayPal Betalingen zijn ontvangen',
      ppPaymentsNotReceivable: 'PayPal Betalingen worden niet ontvangen',
      vrAccessToken: 'VR-Payment Access Token',
      articleSpanCount: 'Artikel Span Count',
      categorySpanCount: 'Categorie Span Count',
      fullWidthCategories: 'Categorieën op Volledige Breedte',
      showInactiveArticles: 'Toon Interactieve Artikelen',
      askForTableNumber: 'Vraag om Tafelnummer',
      foodAndBeveragesSeparated: 'Eten en Dranken Gescheiden',
      toolbarTitleHidden: 'Werkbalk Titel Verborgen',
      displayCirclePickerDescription: 'Toon Cirkelkiezer Beschrijving',
      toolbarCategoryListVisible: 'Werkbalk Categorielijst Zichtbaar',
      toolbarSidesVisible: 'Werkbalk Zijden Zichtbaar',
      multiLanguage: 'Meertalig',
      printQr: 'QR Afdrukken',
      firstOrderOffset: 'Vroegste Besteloffset',
      orderOffset: 'Minimale Besteloffset',
      lastOrderOffset: 'Laatste Besteloffset',
      dailyUnsnoozeTime: 'Artikel Offset',
      offsetResetEnabled: 'Bereidingstijd resetten ingeschakeld',
      offsetResetTime: 'Tijd',
      pickupBoxKey: 'Pickup Box Sleutel',
      pickupBoxDeviceId: 'Pickup Box Apparaat Id',
      pickupBoxAppId: 'Pickup Box App Id',
      pickupBoxCredentials: 'Pickup Box Inloggegevens',
      id: 'Id',
      apiGateway: 'Api Gateway',
      apiKey: 'Api Sleutel',
      apiSecret: 'Api Geheim',
      apiUrl: 'Api Url',
      establishmentId: 'Vestigings-ID',
      dataTransMerchantId: 'DataTrans Handelaars-ID',
      dataTransMerchantPassword: 'DataTrans Handelaars Wachtwoord',
      dataTransMerchantWebhookKey: 'DataTrans Handelaars Webhook Sleutel',
      pspId: 'Psp Id',
      host: 'Host',
      sdCredentials: 'Sd Inloggegevens',
      orderOffsetHint:
        'Voer hier in hoeveel minuten na opening moeten verstrijken voordat de eerste bestelling wordt geaccepteerd, 60 = 1 uur',
      lastOrderOffsetHint:
        'Voer hier in hoeveel minuten voor sluitingstijd een bestelling mag worden geplaatst, 60 = 1 uur',

      preorderOffset: 'Minimale Voorbesteloffset',
      preorderOffsetHint:
        'Voer hier in hoeveel minuten na opening moeten verstrijken voordat de eerste voorbestelling wordt geaccepteerd, 60 = 1 uur',
      firstPreorderOffset: 'Vroegste Voorbesteloffset',
      lastPreorderOffset: 'Laatste Voorbesteloffset',
      lastPreorderOffsetHint:
        'Voer hier in hoeveel minuten voor sluitingstijd een voorbestelling mag worden geplaatst, 60 = 1 uur',
      phoneHint: 'bijv. +4912345678901',
      autoDeclineTime: 'Annuleertijd',
      uploadedFile: 'Geüpload bestand',
      terms: 'Algemene Voorwaarden',
      imprint: 'Impressum',
      privacy: 'Privacy',
      accessibility: 'Toegankelijkheidsverklaring',
      other: 'Overig document',
      registerCourt: 'Registerrechtbank',
      registerNumber: 'Registernummer',
      chiefExecutives: 'Directeur(en)',
      sepaMandateRef: 'SEPA-mandaatreferentie',
      sepaMandateRegistrationLink: 'SEPA-mandaatregistratielink',
      sepaMandateRegistrationError: 'SEPA-mandaatregistratiefout',
      piggyLoyaltyEnabled: 'Piggy Loyalty Ingeschakeld',
      webAppSlug: 'Web App Slug',
      takeAway: 'Afhaal',
      delivery: 'Bezorging',
      foodspot: 'Foodspot',
      terminalUsername: 'Terminal Gebruikersnaam',
      terminalPassword: 'Terminal Wachtwoord',
      mobileUsername: 'Mobiele Gebruikersnaam',
      mobilePassword: 'Mobiel Wachtwoord',
      deliveryProviders: {
        orderLord: 'OrderLord',
        rushHour: 'Rush Hour',
        woltDrive: 'Wolt Drive',
        ultraDispo: 'Ultra Dispo',
        orderLordEnabled: 'Ingeschakeld',
        orderLordActive: 'OrderLord Beschikbaar (ingesteld door beheerder)',
        orderLordToken: 'OrderLord API Token',
        orderLordPassword: 'OrderLord API Wachtwoord',
        rushhourIntegration: 'Rush Hour Integratie Ingeschakeld',
        rushhourToken: 'Rush Hour Token',
        woltdriveToken: 'Wolt Drive Token',
        woltdriveMerchantId: 'Wolt Drive ID',
        smoothrDispatchEnabled: 'Smoothr Dispatch',
        customerId: 'Klant Id',
        clientId: 'Client Id',
        clientSecret: 'Client Secret',
        batchSize: 'Batchgrootte',
        enabled: 'Ingeschakeld',
        merchantUsername: 'Handelaarsgebruikersnaam',
        merchantPassword: 'Handelaarswachtwoord',
        deliverableOrderTypes: 'Leverbare Besteltypen',
        pinVerificationEnabled: 'Pin-Verificatie Ingeschakeld',
        pinVerificationMinimumAmount: 'Min. Bestel Totaalprijs Pin-Verificatie',
        dishbee: 'Dishbee',
        kurierzentrale: 'Kurierzentrale',
        botToken: 'Bot-Token',
        channelId: 'Kanaal-ID',
        username: 'Gebruikersnaam',
        password: 'Wachtwoord',
        partnerId: 'Partner-ID',
        averageDeliveryTime: 'Gemiddelde Bezorgtijd',
      },
      externalOrderProviders: {
        useExternalProviders: 'Externe besteldiensten gebruiken',
        generalSettings: 'Algemene Instellingen',
        skipExternalOrderValidation: 'Bestelling accepteren met inactieve artikelen',
        skipExternalOrderValidationNotice:
          'Wanneer ingeschakeld, accepteert bestellingen van besteldiensten, zelfs als de bestelling artikelen bevat die zijn GEDEACTIVEERD in smoothr.',
        sendOrdersWithInactiveArticlesToPos: 'Stuur de bestelling met inactief artikel naar de POS',
        orderDirectEnabled: 'OrderDirect Ingeschakeld',
        orderDirectImprint: 'OrderDirect Impressum',
        woltEnabled: 'Wolt Ingeschakeld',
        autoSyncTimesEnabled: 'Tijden automatisch synchroniseren',
        enableAutoOrderReady: 'Bestellingen automatisch als gereed instellen',
        connectWolt: 'Ga naar Wolt',
        connectUberEats: 'Ga naar Uber Eats',
        syncAllFoodcards: 'Alle Foodcards Synchroniseren',
        uberEatsEnabled: 'Uber Eats Ingeschakeld',
        jetEnabled: 'JET Ingeschakeld',
        deliverooEnabled: 'Deliveroo Ingeschakeld',
        storeId: 'Winkel-ID',
        siteId: 'Site-ID',
        brandId: 'Merk-ID',
        coverPhotoUrl: 'Menu Afbeelding',
        menuDescription: 'Menu Beschrijving',
        apiVersion: 'API-Versie',
        venue: 'Locatie-ID',
        username: 'Gebruikersnaam',
        password: 'Wachtwoord',
        orderApiKey: 'Bestel-Api-Sleutel',
        apiKey: 'Api-Sleutel',
        syncFoodcard: 'Foodcard synchroniseren',
        syncStatus: 'Locatie Synchronisatiestatus',
        syncOpeningHours: 'Openingstijden synchroniseren',
        foodcardSyncStarted: 'Menusynchronisatie is aan de wachtrij toegevoegd en wordt binnenkort gestart.',
        online: 'De locatie is geactiveerd. Bestellingen zijn nu mogelijk',
        offline: 'De locatie is gedeactiveerd. Bestellingen zijn niet mogelijk.',
        openingHoursSynched: 'De openingstijden zijn gesynchroniseerd.',
        preparationTime: 'Gemiddelde voorbereidingstijd',
        deliveryTime: 'Gemiddelde bezorgtijd',
        autoAccept: 'Bestellingen automatisch accepteren',
        autoAcceptByPos: 'Automatisch accepteren (POS)',
        ocuFlowEnabled: 'OCU Flow',
        articleAvailabilitySyncEnabled: 'Artikelbeschikbaarheid Synchroniseren',
        clientId: 'Client-Id',
        clientSecret: 'Client-Secret',
        checkoutIntegrationDelayingEnabled: 'Checkout integratie vertragen (POS)',
        autoSyncEnabled: 'Foodcard automatisch synchroniseren',
        enforceDeliveryMenuHours: 'Bezorgmenu-uren afdwingen',
        providerTabletEnabled: 'Provider Tablet Ingeschakeld',
        ignorePosStatusEvents: 'POS Gebeurtenissen Negeren',
        dispatchMode: 'Bezorgmodus',
        articleDependencyMode: 'Artikelafhankelijkheidsmodus',
        providerVenueModes: {
          provider_delivery: 'Bezorging door provider',
          own_delivery: 'Bezorging door het restaurant',
        },
        articleDependencyModes: {
          ignore_article: 'Hoofdartikel negeren',
          ignore_dependency_only: 'Artikel toevoegen, maar afhankelijkheden negeren',
        },
        refreshAlert: 'Vernieuw de pagina om de wijzigingen te zien',
        shouldReplaceDeposit: 'Statiegeldartikel vervangen',
        visible: 'Zichtbaar',
        defaultPreparationTime: 'Standaard voorbereidingstijd',
        defaultPreparationTimeHint:
          'Als de automatische reset is ingeschakeld, wordt de voorbereidingstijd na een bepaalde tijd automatisch op deze waarde ingesteld.',
      },
      invoiceReceiver: {
        email: 'Alternatief e-mailadres factuurontvanger (anders wordt contact-e-mail gebruikt)',
      },
      deliveryFeesAfterCreation: 'Bezorgkosten kunnen na aanmaak worden gespecificeerd in de locatie-instellingen.',
      sanifairEnabled: 'Sanifair-Integratie',
      sanifairBingoEnabled: 'Sanifair Bingo Actief',
      sanifairLocationId: 'Sanifair-Locatie-Id',
      sanifairDeviceId: 'Sanifair-Apparaat-Id',
      addExternalDelivery: 'Externe bezorgdienst toevoegen',
      deleteExternalDelivery: 'Verwijderen',
      customerSupportMail: {
        email: 'E-Mail',
      },
      sandboxUrl: 'Sandbox Url',
      clientId: 'ClientId',
      clientSecret: 'Client Secret',
      username: 'Gebruikersnaam',
      password: 'Wachtwoord',
      recordType: 'Record Type',
      channelPc: 'Kanaal Pc',
      enabled: 'Ingeschakeld',
      ccvApikey: 'ccvApikey',
      comoApiKey: 'comoApiKey',
      installationId: 'Installatie Id',
      locationId: 'Locatie Id',
      authenticationToken: 'Authenticatietoken',
      defaultTemplate: 'Standaardsjabloon',
      disabledFields: 'Uitgeschakelde Velden',
      disabledFieldsList: {
        allergens: 'Allergenen',
        template: 'Sjabloon',
        pictograms: 'Pictogrammen',
        description_translations: 'Beschrijving Vertalingen',
        disclamer_translations: 'Disclaimer Vertalingen',
      },
      syncMenu: 'Menu Synchroniseren',
      activateForm: 'Activeer Het Formulier',
      boardingPassVerificationEnabled: 'Boarding-Pass Valideren',
      paxControlScanningPositionId: 'Pax Control Scanning Position Id',
      costCenter: 'Kostenplaats',
      ecrNumber: 'ECR Nummer',
      account: 'Rekening',
      offsetAccount: 'Verrekeningsrekening',
      actions: {
        addPaymentMapping: 'Betaalmethode Toewijzing Toevoegen',
        removePaymentMapping: 'Betaalmethode Toewijzing Verwijderen',
        addOrderTypeMapping: 'Besteltype Toewijzing Toevoegen',
        removeOrderTypeMapping: 'Besteltype Toewijzing Verwijderen',
      },
      paymentMethodMappings: 'Betaalmethode Toewijzingen',
      orderTypeMappings: 'Besteltype Toewijzingen',
      checkoutIntegrationProps: {
        serviceUrl: 'Service Url',
        orgname: 'Org naam',
        orgShortName: 'Org Korte Naam',
        locRef: 'Loc Ref',
        rvcRef: 'Rvc Ref',
        username: 'Gebruikersnaam',
        password: 'Wachtwoord',
        clientId: 'Client Id',
        authUrl: 'Auth Url',
        defaultEmployee: 'Standaard Medewerker',
        defaultOrderType: 'Standaard Besteltype',
        orderTypeInside: 'Besteltype Binnen',
        orderTypeTakeAway: 'Besteltype Afhaal',
        orderTypeDelivery: 'Besteltype Bezorging',
        orderTypeFoodspot: 'Besteltype Foodspot',
        serviceChargeTip: 'Servicekosten Fooi',
        serviceChargeDeliveryFee: 'Servicekosten Bezorgkosten',
        orderTypeInsideTerminal: 'Besteltype Binnen Terminal',
        orderTypeTakeAwayTerminal: 'Besteltype Afhaal Terminal',
        firetimeOffset: 'Firetime Offset',
        averageDeliveryTime: 'Gemiddelde Bezorgtijd',
        useExternalId: 'Gebruik Externe Id',
        autoSyncEnabled: 'Autosync Inschakelen',
        priceAutoSyncEnabled: 'Prijs Autosync Inschakelen',
        useSanifairAsTender: 'Gebruik Sanifair Als Tender',
        useTableAsEmployee: 'Gebruik Tafel Als Medewerker',
        useCodeAsOrderCode: 'Gebruik Code Als Bestelcode',
        useSecondaryCodeAsOrdercode: 'Gebruik Secundaire Code Als Bestelcode',
        retryOnApiCrash: 'Opnieuw proberen Bij Api Crash',
        skipRetryOnPosError: 'Overslaan Herhalen Bij POS Fouten',
        useZeroCode: 'Gebruik Zero Code',
        orderChannelRef: 'Bestelkanaal Ref',
        orderChannelRefMapping: 'Bestelkanaal Ref Toewijzing',
        addOrderChannelRefMapping: 'Bestelkanaal Ref Toewijzing Toevoegen',
        firetimeEnabled: 'Firetime Ingeschakeld',
        sendOrderNotes: 'Bestelnotities Versturen',
        hideTableName: 'Verberg Tafelnaam',
        healthcheckEnabled: 'Gezondheidscheck Ingeschakeld',
        multiConventional: 'Multi Conventional',
        cancelTenderType: 'Besteltype Annuleren',
        cashPaymentCancelTimeout: 'Contante Betaling Annuleren Time-out',
        useCancelTenderType: 'Gebruik Besteltype Annuleren',
        excludedTenders: 'Uitgesloten Tenders (van Multi-Conventional)',
        multiConventionalRevenueCenters: 'Multi Conventional Revenue Centers',
        multiConventionalOrderProfiles: 'Multi Conventional Order Profiles',
        sentBoardingPassEnabled: 'Boarding pass verzenden ingeschakeld',
        sentRbiLoyaltyEnabled: 'RBI Loyalty verzenden ingeschakeld',
        recalculatePayment: 'Betaling Herberekenen',
        replaceCashOrdersByVirtualOrders: 'Contante Bestellingen Vervangen door Virtuele Bestellingen',
        deepHierarchyOnMultiConventionalOrders: 'Diepe Hiërarchie bij Multiconventionele Bestellingen',
        priceSequence: 'Prijsvolgorde',
        orderProfile: 'Bestelprofiel',
        taxRate: 'Belastingtarief',
        sku: 'SKU',
        value: 'Waarde',
        prices: 'Prijzen',
        zeroPaymentMapping: 'Betaalmethode Toewijzing (Zero Payment)',
        postfinanceMapping: 'Betaalmethode Toewijzing (Postfinance)',
        preparationTime: 'Gemiddelde Voorbereidingstijd',
        deliveryTime: 'Gemiddelde Bezorgtijd',
        piggyPrepaidBalance: 'Piggy Prepaid Saldo',
        piggyGiftCard: 'Piggy Cadeaukaarten',
        allowManualBooking: 'Handmatige boeking toestaan',
        useTerminalName: 'Gebruik terminalnaamveld in plaats van "TERMINAL"',
        sendTableNumberAsOrderNote: 'Tafelnummer als bestelnotitie verzenden',
        financialApiEnabled: 'Bonnen geactiveerd',
        discountArticles: 'Kortingsartikelen',
        discountAsArticlesEnabled: 'Kortingen als artikelen verzenden',
        revenueCenter: 'Revenue Center',
        terminalRevenueCenters: 'Terminal Revenue Centers',
        preOrderRevenueCenters: 'Voorbestel Revenue Centers',
        externalOrderProviderRevenueCenters: 'Externe Besteldienst Revenue Centers',
        addTerminalRevenueCenter: 'Terminal Revenue Center Toevoegen',
        addPreOrderRevenueCenter: 'Voorbestel Revenue Center Toevoegen',
        addExternalOrderProviderRevenueCenter: 'Externe Besteldienst Revenue Center Toevoegen',
        externalOrderProviderType: 'Extern Besteldienst Type',
        cncEnabled: 'CNC Ingeschakeld',
        webhookEnabled: 'Simphony Webhooks Ingeschakeld',
        cncAuthUrl: 'CNC Authenticatie-URL',
        cncUsername: 'CNC Gebruikersnaam',
        cncPassword: 'CNC Wachtwoord',
        cncClientId: 'CNC Client Id',
        cncApiUrl: 'CNC API URL',
        cncHierUnit: 'CNC Hier Unit Id',
        useNotesAsOrderCodeEnabled: 'Bestelnotities als bestelcode verzenden',
        default: 'Standaard',
        paymentMethod: 'Betaalmethode',
        revelType: 'Revel Type',
        ncrType: 'NCR Type',
        useSimphonyPrice: 'Gebruik Simphony Prijs',
        disabledFields: 'Gedeactiveerde Payload-Velden',
        stockMode: 'Voorraadmodus',
        nepOrganization: 'Nep Organisation',
        nepEnterpriseUnit: 'Nep Enterprise Unit',
        secretKey: 'Secret Key',
        sharedKey: 'Shared Key',
        integrationKey: 'Integration Key',
        license: 'License',
        tipPaymentMethod: 'Fooi Betaalmethode',
        arcavisId: 'Arcavis Id',
      },
      addTip: 'Fooi Toevoegen',
      removeTip: 'Fooi Verwijderen',
      addDefaultTip: 'Standaard Fooi Toevoegen',
      tipEnabled: 'Fooi Ingeschakeld',
      orderType: 'Besteltype',
      subOrderTypes: 'Sub Besteltypen',
      subOrderType: 'Sub Besteltype',
      defaultTips: 'Standaard Fooien',
      defaultTipValue: 'Standaard Fooi Waarde',
      defaultTipType: 'Standaard Fooi Type',
      defaultTip: 'Standaard Fooi',
      panicReason: 'Panic Reden',
      accountName: 'Rekeningnaam',
      tipTypes: {
        absolute: 'Vaste waarde',
        relative: 'Percentage',
        any: 'Elke waarde',
      },
      salesforcePromotionsEnabled: 'Salesforce Promoties Ingeschakeld',
      voucherify: {
        enabled: 'Ingeschakeld',
        appId: 'App ID',
        appKey: 'App Key',
        loyaltyCampaign: 'Loyaliteitscampagne',
      },
      grubtech: {
        enabled: 'Ingeschakeld',
        storeId: 'Winkel ID',
        apiKey: 'API Key',
        partnerId: 'Partner ID',
        integrationName: 'Integratie naam',
      },
      finances: {
        customerNumber: 'Klantnummer',
        licences: 'Licenties',
        sot: 'Aantal SOT',
        sco: 'Aantal SCO',
        operator: 'Aantal Operator-Licenties',
        pickup: 'Aantal PickUp-Licenties',
        driveIn: 'Aantal DriveIn-Licenties',
        menuboard: 'Aantal Menuboard-Licenties',
        custom: 'Extra Licenties',
        hardware: 'Hardware/Apparaten',
        addHardware: 'Hardware/Apparaat Toevoegen',
        removeHardware: 'Hardware/Apparaat Verwijderen',
        count: 'Aantal',
        rentStartedAt: 'Huur gestart op',
        rentEndedAt: 'Huur geëindigd op',
      },
    },
    legal: {
      useTemplate: 'Gebruik Sjabloon',
      termsHtml: '',
      imprintHtml: '',
      privacyHtml: '',
      accessibilityHtml: '',
      otherHtml: '',
    },
    infoOpeningHours: {
      openingHours: `- U kunt openingstijden voor individuele dagen toevoegen door op een dag te klikken en een tijdslot te kiezen. Om de openingstijden op te slaan, klikt u op het klokpictogram.<br />
      - Door meerdere dagen per week tegelijk te selecteren, kunt u dezelfde openingstijden voor die dagen toevoegen. Om de openingstijden op te slaan, klikt u op het klokpictogram.<br />
      - U kunt ook meerdere openingstijden voor één dag toevoegen door de stappen voor het instellen van individuele openingstijden te herhalen.`,
      specialOpeningHours: `- Als u wilt dat uw restaurant op een specifieke dag speciale openingstijden heeft (bijv. feestdagen), kunt u deze hier toevoegen. Kies gewoon een datum en voeg de speciale tijden toe.<br />
      - Als u uw restaurant op een specifieke datum wilt sluiten, kunt u de dag kiezen en het selectievakje Restaurant gesloten aanvinken. Het restaurant is de hele dag gesloten.<br />
      - Als u uw restaurant voor een specifieke tijdsperiode op een speciale datum moet sluiten, kunt u de datum en een tijdslot kiezen en vervolgens het selectievakje Restaurant gesloten aanvinken. Het restaurant is voor dit specifieke tijdslot gesloten.<br />
      - Zorg ervoor dat u eerst openingstijden hebt toegevoegd. Anders worden uw speciale openingstijden niet opgeslagen.`,
    },
    infoDeliveryHours: {
      deliveryHours: `- U kunt bezorgtijden voor individuele dagen toevoegen door op een dag te klikken en een tijdslot te kiezen. Om de bezorgtijden op te slaan, klikt u op het klokpictogram.<br />
      - Door meerdere dagen per week tegelijk te selecteren, kunt u dezelfde bezorgtijden voor die dagen toevoegen. Om de bezorgtijden op te slaan, klikt u op het klokpictogram.<br />
      - U kunt ook meerdere bezorgtijden voor één dag toevoegen door de stappen voor het instellen van individuele bezorgtijden te herhalen.`,
      specialDeliveryHours: `- Als u wilt dat uw restaurant op een specifieke dag speciale bezorgtijden heeft (bijv. feestdagen), kunt u deze hier toevoegen. Kies gewoon een datum en voeg de speciale tijden toe.<br />
      - Als u uw restaurant op een specifieke datum wilt sluiten voor bezorging, kunt u de dag kiezen en het selectievakje Restaurant gesloten aanvinken. Het restaurant is de hele dag gesloten voor bezorging.<br />
      - Als u uw restaurant voor een specifieke tijdsperiode op een speciale datum moet sluiten voor bezorging, kunt u de datum en een tijdslot kiezen en vervolgens het selectievakje Restaurant gesloten aanvinken. Het restaurant is voor dit specifieke tijdslot gesloten voor bezorging.<br />
      - Zorg ervoor dat u eerst bezorgtijden hebt toegevoegd. Anders worden uw speciale bezorgtijden niet opgeslagen.`,
    },
  },
  analytic: {
    from: 'Van',
    to: 'Tot',
  },
  stats: {
    index: 'Statistieken Beheren',
    indexAnalytics: 'Analyse Beheren',
    totalNumberOfOrders: 'Aantal Bestellingen',
    avgOrdersPerDay: 'Ø Aantal Bestellingen/Dag',
    avgAmount: 'Ø Bestelwaarde',
    totalAmount: 'Totale Som',
    totalSoldArticles: 'Verkochte Artikelen',
    highestDaysSale: 'Hoogste Dagomzet',
    totalPreCheckouts: 'Bevestigde Precheckouts',
    paymentMethod: 'Betaalmethode',
    avgOrderDuration: 'Ø Besteltijd',
    totalTimeouts: 'Aantal time-outs',
    monthSales: 'Maandverkoop',
    selectVenue: 'Selecteer eerst locatie',
    customerGroup: 'Klantengroep',
    ui: {
      country: 'Land',
      search: 'Zoeken',
      bestSold: 'Best verkocht',
      worstSold: 'Slechtst verkocht',
      ordersView: 'Bestellingen weergave',
      articleView: 'Artikelweergave',
      quantity: 'Aantal',
      orders: 'Bestellingen',
      price: 'Prijs',
      refresh: 'Vernieuwen',
      debug: 'TESTEN',
      prod: 'LIVE',
      customerGroup: 'Klantengroep',
      flavor: 'Selecteer Sma(a)k(en)',
      status: 'Selecteer Status(sen)',
      checkoutIntegrationStatus: 'Selecteer POS Status(sen)',
      paymentMethod: 'Selecteer Betaalmethode(n)',
      smoothrOnly: 'Alleen Smoothr',
      table: 'Selecteer Type(n)',
      type: 'Selecteer Tafel(s)',
      platforms: 'Selecteer Platform(s)',
      label: 'Selecteer Label',
      externalOrderProvider: 'Selecteer Provider',
      searchId: 'Zoek ID',
      searchCode: 'Zoek Code',
      number: 'Nummer',
      copyOrderId: 'Bestel ID kopiëren',
      orderId: 'Bestel Id',
      note: 'Notitie',
      today: 'Vandaag',
      yesterday: 'Gisteren',
      monthly: 'Maandelijks',
      daily: 'Dagelijks',
      showReceipts: 'Toon Bonnen',
      showLogs: 'Toon Logs',
      logs: 'Logs',
      more: 'meer',
      deliveryFee: 'Bezorgkosten',
    },
    table: {
      order: 'Bestelling',
      paymentMethod: 'Betaalmethode',
      date: 'Datum',
      orderDate: 'Besteldatum',
      orderTime: 'Besteltijd',
      customer: 'Klant',
      time: 'Tijd',
      qty: 'Aantal',
      venue: 'Locatie',
      itemName: 'Artikelen',
      allCat: 'Alle Categorieën',
      cat: 'Categorieën',
      type: 'Besteltype',
      subType: 'Bestelsubtype',
      status: 'Status',
      table: 'Tafel',
      price: 'Prijs/Artikel',
      total: 'Totaal',
      name: 'Naam',
      note: 'Notitie',
      secondaryCode: 'Secundaire Code',
      dndCompanyCode: 'Bedrijfscode',
      retry: 'Opnieuw proberen',
      createdAt: 'Gemaakt',
      level: 'Niveau',
      source: 'Bron',
      logs: 'Logs',
      provider: 'Provider',
      loyaltyArticles: 'Loyaliteitsartikelen',
      orderedArticles: 'Bestelde Artikelen',
      clientMeta: 'Client Meta',
      platform: 'Platform',
      device: 'Apparaat',
      browser: 'Browser',
      appVersion: 'App Versie',
      osVersion: 'OS Versie',
      externalOrderId: 'Externe Bestel Id',
      room: 'Kamer',
      pickupStation: 'Ophaalstation',
      checkoutIntegrationStatus: 'POS Status',
      promoCode: 'Promotiecode',
    },
    platforms: {
      web: 'Web',
      ios: 'iOS',
      android: 'Android',
    },
  },
  sales: {
    index: 'Productverkoop',
    ui: {
      category: 'Selecteer Categorie(ën)',
      item: 'Selecteer Item(s)',
      label: 'Selecteer Locatie Label',
      dateType: 'Datumtype',
      createdAt: 'Besteldatum',
      orderAt: 'Ophaal-/Bezorgdatum',
    },
    table: {
      name: 'Naam',
      sales: 'Verkoop',
      total: 'Totaal',
      cat: 'Categorie',
    },
  },
  salesOverview: {
    index: 'Verkoopoverzicht',
    filter: {
      customerGroup: 'Klantengroep',
      flavor: 'Smaak',
    },
    table: {
      venue: 'Locatie',
      webApp: 'Web App',
      terminal: 'Terminal',
      terminalTakeaway: 'Terminal Afhaal',
      terminalInside: 'Terminal Binnen',
      wolt: 'Wolt',
      uberEats: 'Uber Eats',
      jet: 'Jet',
      pickup: 'Afhaal',
      delivery: 'Bezorging',
      total: 'Totaal',
      orders: 'Bestellingen',
      amount: 'Bedrag',
      totalOrders: 'Totaal Bestellingen',
      totalAmount: 'Totaal Bedrag',
      inside: 'Webshop Binnen',
      foodspot: 'Foodspot',
      orderAtTable: 'Bestelling aan Tafel',
    },
  },
  billing: {
    index: 'Facturatie',
    billing: 'Facturatie Exporteren',
    orderCsv:
      'Exporteer Bestellingen (De Export wordt verzonden naar het e-mailadres waarmee u momenteel bent ingelogd.)',
    foodspotExport:
      'Exporteer Foodspot (De Export wordt verzonden naar het e-mailadres waarmee u momenteel bent ingelogd.)',
    paymentMethodCsv:
      'Exporteer Bestellingen per Betaalmethode (De Export wordt verzonden naar het e-mailadres waarmee u momenteel bent ingelogd.)',
    salesCsv: 'Exporteer Verkoop (De Export wordt verzonden naar het e-mailadres waarmee u momenteel bent ingelogd.)',
    salesGroup:
      'Exporteer verkoopgroep (De Export wordt verzonden naar het e-mailadres waarmee u momenteel bent ingelogd.)',
    summary: 'Exporteer Facturatie Samenvatting',
    plainSummary: 'Exporteer Facturatie Platte Samenvatting',
    datev: 'Exporteer Datev',
    articlesOverview: 'Besteltype',
    wallet: 'Portemonnee exporteren',
    form: {
      venue: 'Locatie',
      company: 'Bedrijf',
      label: 'Locatie label',
      flavor: 'Smaak',
      customerGroup: 'Klantengroep',
      withoutTags: 'Filter "lege" tags niet',
      showExpanded: 'Toon uitgebreide gegevens',
      subscribedToMailing: 'Ingeschreven voor nieuwsbrief',
      filterEmptyByMail: 'Filter leeg op mail',
      typeExportFile: 'Type geëxporteerd bestand',
      requiredField: 'Kies een van de velden',
    },
  },
  userExport: {
    index: 'Gebruikerexport',
    userExport: 'Exporteer gebruiker',
    userCsv: 'Exporteer gebruikers',
    userWithNewsletterCsv: 'Exporteer gebruikers met nieuwsbrief',
    form: {},
  },
  activityLogExport: {
    index: 'Activiteiten Log Export',
    activityLogCsv: 'Exporteer logs',
    form: {
      type: 'Type',
      venue: 'Locatie',
      typeExportFile: 'Type geëxporteerd bestand',
    },
  },
  sepa: {
    index: 'SEPA',
    title: 'SEPA instellingen',
    mandate: 'Mandaat',
    sepaMandate: 'SEPA Mandaat',
    venues: 'Locaties',
    createSepa: 'Nieuw SEPA Mandaat Aanmaken',
    debit: 'SEPA Incasso',
    payLast: 'Betaal facturen van laatste 30 dagen',
    notification: {
      cancelError: 'Fout bij annuleren SEPA Mandaat',
      cancelWarning:
        'Weet u zeker dat u dit SEPA Mandaat wilt annuleren? Het wordt verwijderd en kan niet meer worden gebruikt voor betalingen.',
      createError: 'Kon geen nieuwe SEPA Mandaatregistratielink aanmaken',
      createWarning:
        'Weet u zeker dat u een nieuwe SEPA Mandaatregistratielink wilt aanmaken? Bestaande SEPA Mandaten voor geselecteerde locaties worden verwijderd en kunnen niet meer worden gebruikt voor betalingen.',
      payWarning:
        'SEPA Mandaat bestaat voor deze locatie. Wilt u een nieuwe SEPA Betaling aanmaken voor deze transactie?',
      payLastTransactionsWarning:
        'Weet u zeker dat u betalingen wilt mandateren voor alle facturen van de laatste 30 dagen voor deze locaties? Daarna kunnen individuele betalingen binnen 2 dagen worden geannuleerd. Neem in dat geval onmiddellijk contact op met de ondersteuning.',
      payLastTransactionsSuccess:
        'Facturen van de laatste 30 dagen betaald. U ontvangt voor elke gemandateerde betaling een e-mail. Neem binnen 2 dagen contact op met de ondersteuning als u een van de betalingen wilt annuleren.',
    },
    form: {
      merchantId: 'Handelaars Id',
      venues: 'Locaties',
      merchantName: 'Handelaarsnaam',
      payLastTransactionsAfterCreate: 'Betaal openstaande facturen van de laatste 30 dagen *',
      payLastTransactionsAfterCreateHint:
        'Alle openstaande factuurbedragen van de laatste 30 dagen worden door ons systeem in rekening gebracht na aanmaak van het SEPA-mandaat. U ontvangt in de komende uren een e-mail voor elke gemandateerde betaling. Neem binnen 2 dagen contact op met de ondersteuning als u een van deze betalingen wilt annuleren.',
      sepaMandateRef: 'SEPA Mandaatreferentie',
      sepaMandateRegistrationLink: 'SEPA Mandaatregistratielink',
      sepaMandateRegistrationError: 'SEPA Mandaatregistratiefout',
    },
  },
  productCombos: {
    index: 'Productcombinaties',
    overview: 'Overzicht',
  },
  tips: {
    terminal: 'Terminal',
    webApp: 'WebApp',
    inside: 'Binnen',
  },
  promo: {
    index: 'Promotiecodes Beheren',
    create: 'Nieuwe Promotiecode Aanmaken',
    edit: 'Promotiecode Bewerken',
    exportCsv: 'Exporteren',
    exportSummary: 'Exporteer Samenvatting',
    exportCount: 'Exporteer Activeringssamenvatting',
    overviewCsv: 'Exporteer Promotiecodes',
    exportTeedeliZip: 'Exporteer Teedeli Promotiecodes (*.zip)',
    exportGeneralOverview: 'Exporteer Algemeen Overzicht',
    overview: 'Overzicht',
    add: 'Promotiecode Toevoegen',
    addTeedeli: 'Teedeli Promotiecode Toevoegen',
    addMultiple: 'Meerdere Promotiecodes Toevoegen',
    disableCodes: 'Codes Uitschakelen',
    syncPiggyVouchers: 'Piggy Vouchers Synchroniseren',
    syncPiggyVouchersSuccess: 'Piggy vouchers succesvol gesynchroniseerd.',
    syncPiggyVouchersError: 'Fout bij synchroniseren van Piggy vouchers.',
    disableHint: 'Selecteer eerst een locatie',
    notification: {
      disableSuccess: 'Promotiecodes succesvol uitgeschakeld.',
    },
    types: {
      absolute: 'Absolute Waarde',
      relative: 'Relatieve Waarde',
      bogo: 'BOGO',
      deliveryFee: 'Geen Bezorgkosten',
      reward: 'Beloning',
      giftCard: 'Cadeaukaart',
      freeArticle: 'Gratis Artikel',
      void: 'Ongeldig',
      absoluteArticle: 'Artikelkorting (absoluut) - VEROUDERD',
      relativeArticle: 'Artikelkorting (relatief) - VEROUDERD',
      singleAbsoluteArticle: 'Artikelkorting (absoluut)',
      singleRelativeArticle: 'Artikelkorting (relatief)',
      multipleAbsoluteArticle: 'Meervoudige Artikelkorting (absoluut)',
      multipleRelativeArticle: 'Meervoudige Artikelkorting (relatief)',
      dependencyFreeArticle: 'Afhankelijkheid Gratis Artikel',
      cheapestFreeArticle: 'Goedkoopste Artikel Gratis',
      cheapestHalfArticleDiscountRelative: 'Korting op de helft van de artikelen',
      mostExpensiveArticleDiscountRelative: 'Duurste Artikel Korting (relatief)',
      teedeliPremium: 'Artikelkorting (premium)',
      unlockArticles: 'Artikelen Vrijgeven',
      coupon: 'Coupon',
      multipleFreeArticles: 'Meerdere Gratis Artikelen',
    },
    table: {
      name: 'Naam',
      code: 'Code',
      customerGroup: 'Klantengroep',
      mov: 'Minimale Bestelwaarde',
      from: 'Geldig van',
      to: 'Geldig tot',
      disabled: 'Uitgeschakeld (Alleen Locatie)',
      venues: 'Locaties',
      type: 'Type',
      value: 'Waarde',
      active: 'Actief (Globaal)',
      disabledBy: 'Uitgeschakeld door',
      countries: 'Landen',
      states: 'Staten',
      amount: 'Max. Gebruik',
      unlimited: 'Onbeperkt',
    },
    form: {
      offerPeriod: 'Aanbiedingsperiode',
      unlimitedTime: 'Onbeperkte Tijd',
      unlimitedAmount: 'Onbeperkt Gebruik',
      lightspeedCode: 'Lightspeed Code',
      simphonyCode: 'Simphony Code',
      useCustomerRedemptionCodes: 'Promotiecodes als eenmalige codes',
      name: 'Naam',
      code: 'Code',
      description: 'Beschrijving',
      venue: 'Locatie',
      valid: 'Geldig',
      article: 'Artikel',
      generateAmount: 'Te genereren aantal',
      label: 'Locatie Label',
      isMultipleApplicable: 'Klant kan het meer dan eens gebruiken',
      applyOnAnyQuantity: 'Toepassen Op Elke Hoeveelheid',
      customerGroup: 'Klantengroep',
      countries: 'Landen',
      states: "Staten/Regio's",
      codes: 'Promotiecodes',
      uploadGiftCards: 'CSV-bestand met Cadeaukaarten',
      venues: 'Locaties',
      type: 'Type',
      freeArticle: 'Gratis Artikel',
      bogoArticles: 'Mogelijke Artikelen (goedkoopste product uit winkelwagen wordt gebruikt voor bogo)',
      mov: 'Minimale Bestelwaarde',
      amount: 'Maximaal gebruik',
      amountTeedeli: 'Aantal promotiecodes',
      amountUsesTeedeli: ' Max. Gebruik',
      active: 'Actief',
      value: 'Waarde',
      discount: 'Korting',
      percent: 'Waarde (bijv. 20% voer 0.2 in)',
      standardAvailability: 'Beschikbaar',
      insideAvailability: 'Beschikbaar binnen',
      takeAwayAvailability: 'Beschikbaar voor afhaal',
      deliveryAvailability: 'Beschikbaar voor bezorging',
      preorderParkCollect: 'Beschikbaar voor park & collect',
      preorderFoodspot: 'Beschikbaar voor foodspot',
      webAvailability: 'Beschikbaar',
      isMaster: 'Is Master',
      generalPromoCode: 'Algemene Promotiecode',
      registrationRequired: 'Registratie Vereist',
      boundToUser: 'Gebonden Aan Gebruiker',
      usageFrequency: 'Gebruiksfrequentie',
      minQuantity: 'Minimale Hoeveelheid',
      maxQuantity: 'Max. aantal kortingsartikelen',
      isAutomatic: 'Automatisch activeren',
      isPiggyVoucher: 'Piggy Voucher',
      banner: 'Banner',
      discountableMainCategories: 'Kortingsbare Hoofdcategorieën',
    },
    usageFrequency: {
      any: 'Elke',
      daily: 'Dagelijks',
      weekly: 'Wekelijks',
      monthly: 'Maandelijks',
    },
    tabs: {
      general: 'Algemeen',
      availability: 'Beschikbaarheid',
      images: 'Afbeeldingen',
      availableHours: 'Beschikbare uren',
      banner: 'Banner',
    },
    standardAvailability: 'Standaard Beschikbaarheid',
    terminalAvailability: 'Terminal Beschikbaarheid',
    preorderAvailability: 'Voorbestel Beschikbaarheid',
    webAvailability: 'Web Beschikbaarheid',
    weekdaysAvailability: 'Weekdagen Beschikbaarheid',
    cateringAvailability: 'Catering Beschikbaarheid',
  },
  cupCode: {
    index: 'Bekercodes Beheren',
    create: 'Nieuwe Bekercode Aanmaken',
    edit: 'Bekercode Bewerken',
    overview: 'Overzicht',
    add: 'Bekercode Toevoegen',
    downloadCodes: 'Codes Exporteren',
    downloadQRCode: 'QR-codes downloaden',
    action: 'Acties op een reeks codes',
    form: {
      number: 'Nummer',
      venue: 'Locatie',
      active: 'Actief',
      quantity: 'Aantal te genereren codes',
      startingFrom: 'Startnummer van codes',
      customerGroup: 'Selecteer klantengroepen',
      format: 'Selecteer bestandsformaat',
    },
    table: {
      number: 'Nummer',
      venue: 'Locatie',
      customerGroup: 'Klantengroepen',
      quantity: 'Aantal',
      startingFrom: 'Start Vanaf',
      active: 'Actief',
      qrCode: 'QR Code',
      createdAt: 'Gemaakt',
    },
    filter: {
      customerGroup: 'Klantengroepen',
      active: 'Actief',
      numFrom: 'Nummer Van',
      numTo: 'Nummer Tot',
    },
  },
  coupon: {
    index: 'Coupons Beheren (verouderd)',
    create: 'Nieuwe Coupon Aanmaken',
    edit: 'Coupon Bewerken',
    exportCsv: 'Exporteren',
    exportSummary: 'Exporteer Samenvatting',
    exportCount: 'Exporteer Activeringssamenvatting',
    overviewCsv: 'Exporteer Coupon',
    overview: 'Overzicht',
    add: 'Coupon Toevoegen',
    addMultiple: 'Meerdere Coupons Toevoegen',
    disableCodes: 'Coupon Uitschakelen',
    disableHint: 'Selecteer eerst een locatie',
    notification: {
      disableSuccess: 'Coupon succesvol uitgeschakeld.',
    },
    form: {
      offerPeriod: 'Aanbiedingsperiode',
      lightspeedCode: 'Lightspeed Code',
      name: 'Naam',
      code: 'Code',
      venue: 'Locatie',
      valid: 'Geldig',
      article: 'Artikel',
      generateAmount: 'Te genereren aantal',
      label: 'Locatie Label',
      isMultipleApplicable: 'Klant kan het meer dan eens gebruiken',
      applyOnAnyQuantity: 'Toepassen Op Elke Hoeveelheid',
      customerGroup: 'Klantengroep',
      countries: 'Landen',
      states: "Staten/Regio's",
      codes: 'Coupon',
      uploadGiftCards: 'CSV-bestand met Cadeaukaarten',
      venues: 'Locaties',
      type: 'Type',
      freeArticle: 'Gratis Artikel',
      bogoArticles: 'Mogelijke Artikelen (goedkoopste product uit winkelwagen wordt gebruikt voor bogo)',
      mov: 'Minimale Bestelwaarde',
      amount: 'Maximaal gebruik',
      active: 'Actief',
      value: 'Waarde',
      discount: 'Korting',
      percent: 'Waarde (bijv. 20% voer 0.2 in)',
      standardAvailability: 'Beschikbaar',
      insideAvailability: 'Beschikbaar binnen',
      takeAwayAvailability: 'Beschikbaar voor afhaal',
      deliveryAvailability: 'Beschikbaar voor bezorging',
      preorderParkCollect: 'Beschikbaar voor park & collect',
      preorderFoodspot: 'Beschikbaar voor foodspot',
      webAvailability: 'Beschikbaar',
      image: 'Afbeelding',
      banner: 'Banner',
      usageFrequency: 'Gebruiksfrequentie',
      redeemableAtCheckoutOnly: 'Inwisselbaar',
    },
    types: {
      absolute: 'Absolute Waarde',
      relative: 'Relatieve Waarde',
      bogo: 'BOGO',
      deliveryFee: 'Geen Bezorgkosten',
      reward: 'Beloning',
      giftCard: 'Cadeaukaart',
      freeArticle: 'Gratis Artikel',
      void: 'Ongeldig',
      absoluteArticle: 'Artikelkorting (absoluut)',
      relativeArticle: 'Artikelkorting (relatief)',
      plusOneFree: '1 + 1 Gratis',
    },
    usageFrequency: {
      any: 'Elke',
      daily: 'Dagelijks',
      weekly: 'Wekelijks',
      monthly: 'Maandelijks',
    },
    table: {
      name: 'Naam',
      code: 'Code',
      customerGroup: 'Klantengroep',
      mov: 'Minimale Bestelwaarde',
      from: 'Geldig van',
      to: 'Geldig tot',
      disabled: 'Uitgeschakeld (Alleen Locatie)',
      venues: 'Locaties',
      type: 'Type',
      value: 'Waarde',
      active: 'Actief (Globaal)',
      disabledBy: 'Uitgeschakeld door',
      countries: 'Landen',
      states: 'Staten',
      amount: 'Max. Gebruik',
    },
    tabs: {
      general: 'Algemeen',
      availability: 'Beschikbaarheid',
      images: 'Afbeeldingen',
    },
    standardAvailability: 'Standaard Beschikbaarheid',
    terminalAvailability: 'Terminal Beschikbaarheid',
    preorderAvailability: 'Voorbestel Beschikbaarheid',
    webAvailability: 'Web Beschikbaarheid',
    weekdaysAvailability: 'Weekdagen Beschikbaarheid',
    cateringAvailability: 'Catering Beschikbaarheid',
  },
  receipt: {
    index: 'Bonnen',
    overview: 'Overzicht',
    receipts: 'Bonnen',
    endOfDayReceipts: 'Einde Dag Bonnen',
    form: {
      flavor: 'Bestelsmaak',
      venue: 'Locatie',
    },
    table: {
      code: 'Bestelcode',
      at: 'Om',
      sum: 'Som',
      endOfDay: 'Einde dag',
      merchantReceipt: 'Handelaarsbon',
      customerReceipt: 'Klantenbon',
      posCheckoutReceipt: 'Afrekenbon',
      exportCustomer: 'Exporteer klantenbon',
      exportMerchant: 'Exporteer handelaarsbon',
      exportCombined: 'Exporteer handelaars- en klantenbon',
      exportFull: 'Exporteer bonnen',
      tableNumber: 'Tafelnummer',
    },
  },
  eposJobs: {
    index: 'Taken',
    overview: 'Overzicht',
    form: {
      venue: 'Locatie',
      status: 'Status',
      requestId: 'Verzoek Id',
      success: 'Succes',
      failed: 'Mislukt',
      partiallyFailed: 'Gedeeltelijk Mislukt',
      pending: 'In Afwachting',
      started: 'Gestart',
      sortByCreatedAt: 'Datum laatst aangemaakt',
      oldestToNewest: 'Oudste Naar Nieuwste',
      newestToOldest: 'Nieuwste Naar Oudste',
    },
    table: {
      sapNumber: 'Sap Nummer',
      status: 'Status',
      statusMessage: 'Statusbericht',
      createdAt: 'Gemaakt Op',
      finalizedAt: 'Afgerond Op',
      exportFull: 'Exporteer bonnen',
      requestId: 'Verzoek Id',
      ID: 'Wijzigingen ID',
      articleType: 'Artikeltype',
      itemId: 'Item ID',
      price: 'Prijs',
      taxInside: 'BTW Binnen',
      taxTakeaway: 'BTW Afhaal',
      visibility: 'Zichtbaarheid',
      oldValue: 'Oude Waarde',
      newValue: 'Nieuwe Waarde',
      priceRuleId: 'Prijsregel Id',
      effectiveDateTimestamp: 'Ingangsdatum Tijdstempel',
      expirationDateTimestamp: 'Vervaldatum Tijdstempel',
      priceRuleSet: 'Prijsregelset',
      statusCode: 'Statuscode',
      taxIdInside: 'BTW ID Binnen',
      taxIdTakeaway: 'BTW ID Afhaal',
      errorList: 'Foutenlijst',
      errorId: 'Fout ID',
      articleName: 'Artikelnaam',
      negativeFlag: 'Negatieve Vlag',
      exportRawRequest: 'Exporteer Ruw Verzoek',
      exportChanges: 'Exporteer Wijzigingen',
    },
  },
  sanifairLogs: {
    index: 'Sanifair',
    overview: 'Overzicht',
    form: {
      venue: 'Locatie',
      status: 'Status',
      search: 'Zoeken',
      actionTypes: 'Actietypes',
    },
    table: {
      sanifairActionType: 'Actietypes',
      order: 'Bestelling',
      responseTimeSanifair: 'Reactietijd Sanifair',
      responseTimeSmoothr: 'Reactietijd Smoothr',
      responseTimeTotal: 'Totale Reactietijd',
      createdAt: 'Gemaakt Op',
      sanifairRequestReceivedAt: 'Sanifair Verzoek Ontvangen Op',
      sanifairResponseReceivedAt: 'Sanifair Antwoord Ontvangen Op',
      smoothrRequestReceivedAt: 'Smoothr Verzoek Ontvangen Op',
      smoothrResponseReceivedAt: 'Smoothr Antwoord Ontvangen Op',
    },
  },
  automatedReports: {
    index: 'Geautomatiseerde Rapporten',
    overview: 'Overzicht',
    add: 'Geautomatiseerd Rapport Toevoegen',
    form: {
      type: 'Type',
      venue: 'Locatie',
      customerGroup: 'Klantengroep',
      flavor: 'Smaak',
      lang: 'Taal',
      frequency: 'Frequentie',
      venueLabels: 'Locatie Labels',
      lastExecuted: 'Laatst Uitgevoerd',
      receiver: 'Ontvanger',
      cc: 'CC',
      active: 'Actief',
    },
    tabs: {
      general: 'Algemeen',
    },
    table: {
      type: 'Type',
      customerGroup: 'Klantengroep',
      flavor: 'Smaak',
      frequency: 'Frequentie',
      venueLabels: 'Locatie Labels',
      lastExecuted: 'Laatst Uitgevoerd',
      receiver: 'Ontvanger',
      selectVenue: 'Selecteer locatie',
      selectGroup: 'Selecteer klantengroep',
    },
    types: {
      orders: 'Bestellingen',
      orderByPaymentMethod: 'Bestellingen per Betaalmethode',
      sales: 'Verkoop',
      pdfBillingShort: 'PDF Facturatie Kort',
      pdfBillingLong: 'PDF Facturatie Lang',
    },
    frequency: {
      daily: 'Dagelijks',
      weekly: 'Wekelijks',
      monthly: 'Maandelijks',
      yearly: 'Jaarlijks',
    },
  },
  paypal: {
    index: 'PayPal',
    success: 'PayPal-autorisatie was succesvol',
    description:
      'PayPal-autorisatie was succesvol. Nadat onze medewerkers uw accountstatus hebben gecontroleerd, worden PayPal-betalingen geactiveerd.',
  },
  validations: {
    eod_email_enable: 'De lijst moet geldige e-mails bevatten voordat u dit inschakelt',
    list_of_emails: 'Uw e-mailadres moet worden gescheiden door een komma.',
    list_of_integer: 'Uitgesloten tenders moeten worden gescheiden door een komma.',
    numbers_with_comma_or_dot: 'Het {field} veld moet een getal zijn.',
    quantity_number: 'Het aantal mag niet groter zijn.',
    quantity_number_less_100k: 'Het verschil mag niet meer dan 100.000 en minder dan 0 zijn',
    quantity_number_less_10k: 'Het verschil mag niet meer dan 10.000 en minder dan 0 zijn',
    unique_email: 'Het e-mailadres is al in gebruik',
    readable_id: 'De korte ID is al bezet.',
    venue_label: 'Het locatielabel bestaat al.',
    password: 'Wachtwoord moet één hoofdletter, één cijfer of speciaal teken bevatten en minimaal 8 tekens lang zijn.',
    identifier: 'De identificatie mag alleen kleine letters bevatten, gescheiden door een enkele onderstreping',
    date_before: 'Het {field} veld moet vóór {target} zijn',
    time_before: 'Het {field} veld moet vóór {target} zijn',
    unique_dependency: 'De {field} is een duplicaat',
    smaller_eq_than: 'De {field} mag maximaal {target} zijn.',
    smaller_than: 'De {field} moet kleiner zijn dan {target}.',
    greater_than: 'De {field} moet groter zijn dan {target}.',
    greater_eq_than: 'De {field} moet minimaal {target} zijn.',
    uppercase: 'Alleen hoofdletters toegestaan',
    price: 'De {field} moet een geldige prijs zijn (bijv. 1.99)',
    nutritional_value: 'De {field} moet een geldige voedingswaarde zijn (bijv. 1.99)',
    uniqueFile: 'De geüploade media kan niet worden gewijzigd. Maak een nieuwe stap.',
    time: 'Het tijdformaat is HH:mm.',
    url: 'Voer een geldig domein in zonder http/https, alleen het domein en de TLD.',
    url_simple: 'Voer een geldige volledige URL in met http/https',
    url_ios_android: 'De {field} moet een geldige URL zijn voor de {storeType} Store',
    loyalty_campaign: "De {field} moet een geldige campagne zijn die begint met 'camp_'",
    phone: 'Voer een geldig telefoonnummer in (bijv. +4912345678901)',
    uniq_company_code: 'Deze bedrijfscode is al in gebruik. Kies een andere code.',
    iban: 'Ongeldig IBAN-formaat. Voer een correcte IBAN in.',
    vatNumber: {
      info: 'Geldig BTW-nummer met een minimale lengte van 5 vereist',
      error:
        'BTW-nummer is ongeldig of al in gebruik door een andere gebruiker. Voer een ander BTW-nummer in of neem contact op met een beheerder om het probleem op te lossen.',
    },
    vatNumberGermany: {
      info: 'Geldig Duits Belastingnummer met een minimale lengte van 5 vereist',
      error:
        'Duits Belastingnummer is ongeldig of al in gebruik door een andere gebruiker. Voer een ander BTW-nummer in of neem contact op met een beheerder om het probleem op te lossen.',
    },
  },
  footer: {
    imprint: 'Impressum',
    terms: 'Gegevensbeleid',
  },
  reporting: {
    index: 'Rapportage',
    form: {
      type: 'Type',
      periodType: 'Periode',
      label: 'Locatie Label',
      country: 'Land',
      venue: 'Locatie',
      flavor: 'Smaak',
      customerGroup: 'Klantengroep',
    },
    periods: {
      daily: 'Dag',
      weekly: 'Week',
      monthly: 'Maand',
      total: 'Totaal',
    },
    types: {
      stores: 'Locatie',
      products: 'Artikel',
      customers: 'Klant',
    },
  },
  screensaver: {
    index: 'Screensaver',
    add: 'Screensaver Aanmaken',
    mediaType: 'Mediatype',
    duration: 'Duur',
    level: 'Niveau',
    preview: 'voorbeeld',
    title: 'Screensaver Stap',
    hours: 'Uren',
    overview: 'Overzicht',
    stepSavingInfo: 'Media wordt zo geüpload, even geduld.',
    category: 'Categorie',
    form: {
      name: 'Naam',
      customerGroup: 'Klantengroep',
      linkedCustomerGroup: 'Gekoppelde Klantengroep',
      venues: 'Locaties',
      openingHours: 'Openingstijden',
      file: 'Asset',
      duration: 'Duur in seconden',
      level: 'Niveau',
      saveOrder: 'Nieuwe volgorde opslaan',
      changeOrder: 'Volgorde wijzigen',
      slug: 'Slug',
      visible: 'Zichtbaar',
      category: 'Categorie',
      articles: 'Artikelen',
    },
    tabs: {
      screensaver: 'Screensaver',
      upsellArticles: 'Upsell Artikelen',
      steps: 'Stappen',
      info: 'U kunt pas stappen toevoegen nadat u de screensaver heeft aangemaakt',
    },
    table: {
      steps: 'Aantal Stappen',
    },
  },
  employeeNotification: {
    index: 'Medewerker Notificatie',
    add: 'Medewerker Notificatie Aanmaken',
    form: {
      title: 'Titel',
      message: 'Bericht',
    },
  },
  loyaltyPrograms: {
    index: "Loyaliteitsprogramma's",
    add: 'Loyaliteitsprogramma Aanmaken',
    create: 'Loyaliteitsprogramma Aanmaken',
    edit: "Loyaliteitsprogramma's Bewerken",
    overview: 'Overzicht',
    general: 'Algemeen',
    clientCredentials: 'Client Inloggegevens',
    rbiCredentials: 'Rbi Inloggegevens',
    form: {
      type: 'Type',
      customerGroup: 'Klantengroep',
      apikey: 'Api Sleutel',
      oauthId: 'Oauth ID',
      oauthSecret: 'Oauth Secret',
      operator: 'Operator',
      posType: 'Pos Type',
      storeId: 'Winkel Id',
      supportingPos: 'Ondersteunende Pos',
      piggy: 'Piggy',
      como: 'Como',
      internal: 'Intern',
      rbi: 'Rbi',
      shopUuid: 'Shop Uuid',
    },
    table: {
      type: 'Type',
      customerGroup: 'Klantengroep',
      apikey: 'Api Sleutel',
      oauthId: 'Oauth ID',
      oauthSecret: 'Oauth Secret',
      shopUuid: 'Shop Uuid',
      venue: 'Locatie',
      operator: 'Operator',
      posType: 'Pos Type',
      storeId: 'Winkel Id',
      supportingPos: 'Ondersteunende Pos',
    },
  },
  banner: {
    index: 'Banners Beheren',
    add: 'Banner aanmaken',
    table: {
      name: 'Naam',
      type: 'Type',
      linkedCategory: 'Gekoppelde Categorie',
      linkedArticle: 'Gekoppeld Artikel',
    },
    form: {
      name: 'Naam',
      type: 'Type',
      linkedCategory: 'Gekoppelde Categorie',
      linkedArticle: 'Gekoppeld Artikel',
      imageDe: 'Afbeelding (de)',
      imageEn: 'Afbeelding (en)',
      imageFr: 'Afbeelding (fr)',
    },
  },
  lightspeed: {
    syncFoodcard: 'Synchroniseren',
    success: 'Lightspeed is succesvol geautoriseerd',
    successDescription:
      'Gefeliciteerd! Lightspeed is succesvol geautoriseerd. Neem contact op met uw key accountmanager om de integratie te voltooien. U kunt deze pagina nu sluiten.',
    error: 'Lightspeed kon niet worden geautoriseerd',
    errorDescription:
      'Helaas is er een onbekende fout opgetreden bij het autoriseren van Lightspeed. Neem contact op met de ondersteuning of uw key accountmanager. U kunt deze pagina nu sluiten.',
    notification: {
      foodcardSyncSuccess: 'Menu wordt gesynchroniseerd. Dit duurt ongeveer 15 minuten.',
      foodcardSyncError: 'Menu kon niet worden gesynchroniseerd. Informeer een beheerder.',
      tablesSyncSuccess: 'Tafels worden gesynchroniseerd. Dit duurt ongeveer 5 minuten.',
      tablesSyncError: 'Tafels konden niet worden gesynchroniseerd. Informeer een beheerder.',
    },
    modes: {
      create_and_update: 'Alles synchroniseren',
      create_only: 'Nieuwe items synchroniseren',
      update_only: 'Wijzigingen synchroniseren',
      price_and_active: 'Prijzen/zichtbaarheid synchroniseren',
      price_only: 'Alleen prijzen synchroniseren',
      images_only: 'Alleen afbeeldingen synchroniseren',
      tables: 'Tafels synchroniseren',
    },
  },
  copy_venue: {
    not_selected_to: 'U moet een bestemming selecteren om naar te kopiëren',
    success: 'Locatie is succesvol gekopieerd',
    error: 'Er is iets misgegaan',
    btn_title: 'Instellingen Kopiëren',
    from: 'Van',
    to: 'Naar',
  },
  sync: {
    index: 'Synchronisatie',
    sync: 'Synchroniseren',
    syncUpsells: 'Upsells Synchroniseren',
    config: 'Configuratie',
    created: 'Aangemaakt',
    updated: 'Bijgewerkt',
    deleted: 'Verwijderd',
    collapseAll: 'Alles Samenvouwen',
    expandAll: 'Alles Uitvouwen',
    directions: {
      d2d: 'Dev-naar-Dev',
      d2p: 'Dev-naar-Prod',
      p2d: 'Prod-naar-Dev',
      p2p: 'Prod-naar-Prod',
    },
    notification: {
      running: 'De synchronisatie is gestart',
      error: 'Er is een fout opgetreden. Controleer de logs.',
    },
    modes: {
      'master-to-slaves': 'Master -> Slaven',
      'slave-to-slaves': 'Slaaf -> Slaven',
    },
    deleteModes: {
      ignore: 'Geen wijziging/Geen verwijdering',
      soft: 'Soft-Delete',
      hard: 'Hard-Delete',
    },
    table: {
      id: 'Id',
      name: 'Naam',
      user: 'Gebruiker',
      status: 'Status',
      createdAt: 'Gemaakt',
      today: 'Vandaag',
      finishedAt: 'Voltooid',
      config: 'Configuratie',
      changes: 'Wijzigingen',
      stopSync: 'Synchronisatie Stoppen',
      refresh: 'Vernieuwen',
    },
    form: {
      main: 'Hoofd-Locatie (Slaaf/Master)',
      slaves: 'Slaaf-Locaties',
      direction: 'Van/Naar',
      mode: 'Modus',
      deleteMode: 'Verwijder modus',
      articleCategoryProps: 'Categorie-Eigenschappen',
      categories: 'Categorieën',
      articleProps: 'Artikel-Eigenschappen',
      venueProps: 'Locatie-Eigenschappen',
      optionGroupProps: 'Optiegroep-Eigenschappen',
      optionArticleProps: 'Optieartikel-Eigenschappen',
      selectAll: 'Alles Selecteren',
      upsells: 'Upsells',
      useSyncTags: 'Synchroniseren op basis van synchronisatietags',
    },
    props: {
      articleCategory: {
        sortOrder: 'Sorteervolgorde',
        visible: 'Zichtbaarheid',
        displayMode: 'Weergavemodus',
        displayIdentifiers: 'Weergave Identificaties',
        mainCategory: 'Hoofdcategorie',
        availableHours: 'Beschikbare uren',
        name: 'Naam',
        description: 'Beschrijving',
        assets: 'Hoofdafbeelding',
        icon: 'Pictogram',
        tags: 'Tags',
        constrains: 'Beperkingen',
        features: 'Kenmerken',
        mainRecommendations: 'Hoofd aanbevelingen',
        printerSortOrder: 'Printer Sorteervolgorde',
      },
      article: {
        price: 'Prijs',
        basePrice: 'Basisprijs',
        taxTakeaway: 'BTW (Afhaal)',
        taxInside: 'BTW (Binnen)',
        sortOrder: 'Sorteervolgorde',
        visible: 'Zichtbaarheid',
        isActive: 'Actieve status',
        deposit: 'Statiegeld',
        isControlArticle: 'Controleartikel vlag',
        internalNote: 'Interne notitie',
        internalName: 'Interne Naam',
        externalId: 'Externe ID',
        number: 'Nummer',
        priceIsLocked: 'Prijs-Vergrendeling',
        isNoticeable: 'Opvallend',
        description: 'Beschrijving',
        name: 'Naam',
        info: 'Info',
        shortDescription: 'Korte beschrijving',
        assets: 'Hoofdafbeelding',
        icon: 'Pictogram',
        banner: 'Banner',
        measurement: 'Meting',
        groupDependencies: 'Groepsafhankelijkheden',
        groups: 'Optiegroepen',
        defaults: 'Standaarden',
        recommendations: 'Aanbevelingen',
        priceByType: 'Prijs per besteltype',
        displayPriceByType: 'Zichtbare Prijs per besteltype',
        availability: 'Beschikbaarheid',
        tags: 'Tags',
        constrains: 'Beperkingen',
        counterArticle: 'Tegenartikel',
        mainRecommendations: 'Hoofd aanbevelingen',
        articleRelativeBrand: 'Merk',
        styles: 'Stijlen',
        additives: 'Toevoegingen',
        allergens: 'Allergenen',
        features: 'Kenmerken',
        traces: 'Sporen',
        externalOrderProviderSettings: 'Externe Besteldienst Instellingen',
        loyaltyId: 'Loyaliteits Id',
        requiredLoyaltyPoints: 'Vereiste Loyaliteitspunten',
        plu: 'PLU',
        gtin: 'GTIN',
        nutritions: 'Voeding',
        displayMode: 'Weergavemodus',
        displayModeSot: 'Weergavemodus (Sot)',
        displayModeMobile: 'Weergavemodus (Mobiel)',
        manufacturer: 'Fabrikant',
        caffeineMg: 'Cafeïne (mg)',
        alcoholPercentage: 'Alcoholpercentage',
        availableHours: 'Beschikbare Uren',
        printerSortOrder: 'Printer Sorteervolgorde',
        dimension: 'Afmetingen',
        weight: 'Gewicht',
        foodInstructions: 'Voedingsinstructies',
        storageInstructions: 'Bewaarinstructies',
      },
      venue: {
        movDelivery: 'MOV',
        preorderTakeAway: 'Voorbestelling (Afhaal)',
        preorderIn: 'Voorbestelling (Binnen)',
        deliveryEnabled: 'Voorbestelling (Bezorging)',
        sendProvisionReportPeriod: 'Provision rapport',
        isServiceActivated: 'Service-Status',
        offsets: 'Offsets',
        invoiceReceiver: 'Factuurontvanger',
        slot: 'Slotting',
        legal: 'Juridisch',
        openingHours: 'Openingstijden',
        deliveryHours: 'Bezorgtijden',
        nutritionTable: 'Voedingstabel',
        nutritionInfo: 'Voedingsinformatie',
      },
      optionGroup: {
        hasMultiple: 'Meervoudige selectie',
        limit: 'Limiet',
        sortOrder: 'Sorteervolgorde',
        requiredAmount: 'Vereist aantal',
        name: 'Naam',
        description: 'Beschrijving',
        shortDescription: 'Korte beschrijving',
        backgroundImage: 'Achtergrondafbeelding',
        tags: 'Tags',
        displayMode: 'Weergavemodus',
        displayModeSot: 'Weergavemodus (Sot)',
        displayModeMobile: 'Weergavemodus (Mobiel)',
        printerSortOrder: 'Printer Sorteervolgorde',
      },
      optionArticle: {
        price: 'Prijs',
        basePrice: 'Basisprijs',
        taxTakeaway: 'BTW (Afhaal)',
        taxInside: 'BTW (Binnen)',
        sortOrder: 'Sorteervolgorde',
        visible: 'Zichtbaarheid',
        isActive: 'Actieve status',
        deposit: 'Statiegeld',
        isControlArticle: 'Controleartikel vlag',
        internalNote: 'Interne notitie',
        internalName: 'Interne Naam',
        foodInstructions: 'Voedingsinstructies',
        storageInstructions: 'Bewaarinstructies',
        externalId: 'Externe ID',
        optionNumber: 'Nummer',
        number: 'Nummer',
        priceIsLocked: 'Prijs-Vergrendeling',
        isNoticeable: 'Opvallend',
        description: 'Beschrijving',
        name: 'Naam',
        info: 'Info',
        shortDescription: 'Korte beschrijving',
        assets: 'Hoofdafbeelding',
        icon: 'Pictogram',
        banner: 'Banner',
        measurement: 'Meting',
        groupDependencies: 'Groepsafhankelijkheden',
        groups: 'Optiegroepen',
        defaults: 'Standaarden',
        recommendations: 'Aanbevelingen',
        priceByType: 'Prijs per besteltype',
        displayPriceByType: 'Zichtbare Prijs per besteltype',
        availability: 'Beschikbaarheid',
        tags: 'Tags',
        constrains: 'Beperkingen',
        counterArticle: 'Tegenartikel',
        mainRecommendations: 'Hoofd aanbevelingen',
        requirements: 'Artikelvereisten',
        articleRelativeBrand: 'Merk',
        styles: 'Stijlen',
        additives: 'Toevoegingen',
        allergens: 'Allergenen',
        features: 'Kenmerken',
        traces: 'Sporen',
        externalOrderProviderSettings: 'Externe Besteldienst Instellingen',
        loyaltyId: 'Loyaliteits Id',
        requiredLoyaltyPoints: 'Vereiste Loyaliteitspunten',
        plu: 'PLU',
        gtin: 'GTIN',
        nutritions: 'Voeding',
        manufacturer: 'Fabrikant',
        caffeineMg: 'Cafeïne (mg)',
        alcoholPercentage: 'Alcoholpercentage',
        printerSortOrder: 'Printer Sorteervolgorde',
        dimensions: 'Afmetingen',
        weight: 'Gewicht',
      },
      upsell: {
        addon: 'Winkelwagen Upsell',
        goal: 'Afrondings Upsell',
        upgrade: 'Artikel Upsell',
      },
    },
  },
  aggregatorSyncs: {
    index: 'Aggregator Synchronisaties',
    wolt: 'Wolt',
    uberEats: 'Uber-Eats',
    jet: 'Jet',
    deliveroo: 'Deliveroo',
    noWolt: 'Geen Wolt-gegevens beschikbaar.',
    noJet: 'Geen Jet-gegevens beschikbaar.',
    noUberEats: 'Geen Uber-Eats-gegevens beschikbaar.',
    noDeliveroo: 'Geen Deliveroo-gegevens beschikbaar.',
    table: {
      name: 'Naam',
      user: 'Gebruiker',
      status: 'Status',
      createdAt: 'Gemaakt',
      finishedAt: 'Voltooid',
    },
    filter: {
      status: 'Selecteer Status',
    },
    status: {
      created: 'Aangemaakt',
      in_progress: 'Bezig',
      done: 'Klaar',
      failed: 'Mislukt',
    },
  },
  orderProviders: {
    wolt: {
      success: {
        title: 'Locatie is succesvol verbonden met Wolt',
        description:
          'Uw locatie is succesvol verbonden met Wolt. U kunt nu uw foodcard synchroniseren en bestellingen ontvangen.',
      },
      error: {
        title: 'Locatie kon niet worden verbonden met Wolt',
        description: 'Er is een fout opgetreden. Neem contact op met onze ondersteuning:',
      },
    },
    uberEats: {
      success: {
        title: 'Locatie is succesvol verbonden met Uber Eats',
        description:
          'Uw locatie is succesvol verbonden met Uber Eats. U kunt nu uw foodcard synchroniseren en bestellingen ontvangen.',
      },
      error: {
        title: 'Locatie kon niet worden verbonden met Uber Eats',
        description: 'Er is een fout opgetreden. Neem contact op met onze ondersteuning:',
      },
    },
  },
  simphony: {
    syncFoodcard: 'Prijzen/zichtbaarheid synchroniseren',
    syncPrices: 'Alleen prijzen synchroniseren',
    syncActive: 'Alleen zichtbaarheid synchroniseren',
    refreshCnc: 'CNC Vernieuwen',
    fullSync: 'Volledige Synchronisatie',
    addOnly: 'Alleen toevoegen',
    notification: {
      foodcardSyncSuccess: 'Prijzen/zichtbaarheid zijn succesvol gesynchroniseerd.',
      foodcardSyncError: 'Kon prijzen/zichtbaarheid niet synchroniseren. Controleer de logs.',
      pricesSyncSuccess: 'Prijzen zijn succesvol gesynchroniseerd.',
      pricesSyncError: 'Kon prijzen niet synchroniseren. Controleer de logs.',
      activeSyncSuccess: 'Zichtbaarheid is succesvol gesynchroniseerd.',
      activeSyncError: 'Kon zichtbaarheid niet synchroniseren. Controleer de logs.',
      refreshCncSuccess: 'CNC is succesvol vernieuwd.',
      refreshCncError: 'Kon CNC niet vernieuwen. Controleer de logs.',
      addOnlySuccess: 'Nieuwe items zijn succesvol gesynchroniseerd.',
      addOnlyError: 'Kon nieuwe items niet synchroniseren. Controleer de logs.',
    },
  },
  kost: {
    syncFoodcard: 'Foodcard synchroniseren',
    notification: {
      foodcardSyncSuccess: 'Foodcard is succesvol gesynchroniseerd.',
      foodcardSyncError: 'Kon foodcard niet synchroniseren. Controleer de logs.',
    },
  },
  ncr: {
    syncFoodcard: 'Foodcard synchroniseren',
    notification: {
      foodcardSyncSuccess: 'Foodcard is succesvol gesynchroniseerd.',
      foodcardSyncError: 'Kon foodcard niet synchroniseren. Controleer de logs.',
    },
  },
  revel: {
    sync: 'Synchroniseren',
    syncMenu: 'Menu synchroniseren',
    notification: {
      menuSyncSuccess: 'Menu is succesvol gesynchroniseerd.',
      menuSyncError: 'Kon menu niet synchroniseren. Controleer de logs.',
    },
    modes: {
      full: 'Alles synchroniseren',
      add_only: 'Alleen toevoegen',
      price_only: 'Alleen prijzen synchroniseren',
      active_only: 'Alleen zichtbaarheid synchroniseren',
    },
  },
  lina: {
    syncPrices: 'Prijzen synchroniseren',
    notification: {
      pricesSyncSuccess: 'Prijzen zijn succesvol gesynchroniseerd.',
      pricesSyncError: 'Kon prijzen niet synchroniseren. Controleer de logs.',
    },
  },
  ui: {
    banner: {
      index: 'Banners',
      overview: 'Overzicht',
      general: 'Details',
      add: 'Banner Aanmaken',
      create: 'Nieuwe Banner Aanmaken',
      edit: 'Banner Bewerken',
      empty: 'Het lijkt erop dat u nog geen banners heeft toegevoegd. Maak nu uw eerste banner aan!',
    },
    card: {
      index: 'Kaarten',
      overview: 'Overzicht',
      general: 'Details',
      add: 'Kaart Aanmaken',
      create: 'Nieuwe Kaart Aanmaken',
      edit: 'Kaart Bewerken',
      empty: 'Het lijkt erop dat u nog geen kaarten heeft toegevoegd. Maak nu uw eerste kaart aan!',
    },
    slider: {
      index: 'Sliders',
      overview: 'Overzicht',
      general: 'Details',
      add: 'Slider Aanmaken',
      create: 'Nieuwe Slider Aanmaken',
      edit: 'Slider Bewerken',
      empty: 'Het lijkt erop dat u nog geen sliders heeft toegevoegd. Maak nu uw eerste slider aan!',
    },
    form: {
      customerGroup: 'Klantengroep',
      title: 'Titel',
      identifier: 'Identificatie',
      textColor: 'Tekstkleur',
      backgroundColor: 'Achtergrondkleur',
      backgroundImage: 'Achtergrondafbeelding',
      htmlContent: 'HTML Inhoud',
      primaryClickAction: 'Primaire Klikactie',
      type: 'Type',
      value: 'Waarde',
      label: 'Label',
      addAction: 'Actie Toevoegen',
      removeAction: 'Actie Verwijderen',
      slides: 'Slides',
      actionType: 'Actie Type',
      description: 'Beschrijving',
      action: 'Acties',
    },
  },
  releases: {
    index: 'Releases',
    overview: 'Overzicht',
    general: 'Details',
    add: 'Release Aanmaken',
    create: 'Nieuwe Release Aanmaken',
    edit: 'Release Bewerken',
    empty: 'Het lijkt erop dat u nog geen releases heeft toegevoegd. Maak nu uw eerste release aan!',
    form: {
      customerGroup: 'Klantengroep',
      platform: 'Platform',
      version: 'Versie',
      forceUpdate: 'Forceer Update',
      description: 'Beschrijving',
      link: 'Link',
      isLatest: 'Huidige Versie',
      isLatestHint: 'Als het veld actief is, wordt de huidige versie overschreven.',
      platforms: {
        IOS: 'iOS',
        ANDROID: 'Android',
      },
    },
  },
  auditing: {
    index: 'Audit',
    overview: 'Overzicht',
    table: {
      action: 'Actie',
      message: 'Onderwerp',
      target: 'Bron',
      actor: 'Gebruiker',
      changes: 'Wijzigingen',
      createdAt: 'Datum',
      venue: 'Locatie',
      customerGroup: 'Klantengroep',
    },
  },
  enrollments: {
    index: 'Inschrijvingen',
    overview: 'Overzicht',
    accept: 'Accepteren',
    reject: 'Afwijzen',
    comment: 'Opmerking',
    table: {
      deviceType: 'Apparaattype',
      serialNumber: 'Serienummer',
      venue: 'Locatie',
      appInformation: 'App',
      role: 'Rol',
      enrollmentStatus: 'Status',
      rolloutStatus: 'Uitrol Status',
      isActive: 'Actief',
      venues: 'Locaties',
      reviewerId: 'Beoordelaar ID',
    },
  },
  campaign: {
    index: 'Campagne',
    overview: 'Overzicht',
    general: 'Details',
    add: 'Campagne Aanmaken',
    create: 'Nieuwe Campagne Aanmaken',
    edit: 'Campagne Bewerken',
    empty: 'Het lijkt erop dat u nog geen campagnes heeft toegevoegd. Maak nu uw eerste campagne aan!',
    form: {
      customerGroup: 'Klantengroep',
      name: 'Naam',
      content: 'Inhoud',
      subject: 'Onderwerp',
      clickAction: 'Klikactie',
      url: 'URL',
      venues: 'Locaties',
      status: 'Status',
      error: 'Fout',
      scheduledAt: 'Gepland',
    },
    table: {
      customerGroup: 'Selecteer Klantengroep',
    },
  },
  seasonPass: {
    index: 'Season Pass',
    warning: 'Een succesvolle import overschrijft alle bestaande vermeldingen.',
    upload: 'Upload CSV',
    csv: 'Season Pass CSV-bestand',
    successfulUpload: 'Uw Season Pass CSV-bestand is succesvol geüpload',
  },
  upsell: {
    index: 'Upsells',
    overview: 'Overzicht',
    types: {
      addon: 'Winkelwagen Upsell',
      goal: 'Afrondings Upsell',
      upgrade: 'Artikel Upsell',
    },
    table: {
      position: 'Positie',
      article: 'Artikel',
      upgradeFrom: 'PLU Klein',
      upgradeTo: 'PLU Groot',
      mov: 'Minimale bestelwaarde',
      roundTo: 'Afgerond op',
      articles: 'PLU om toe te voegen',
      plu: 'PLU',
    },
    form: {
      position: 'Positie',
      article: 'Artikel',
      upgradeFrom: 'PLU Klein',
      upgradeTo: 'PLU Groot',
      mov: 'Minimale bestelwaarde',
      roundTo: 'Afgerond op',
      articles: 'PLU om toe te voegen',
      isMaster: 'Is Master',
      isMasterNotice:
        'Vergeet niet de "Is Master"-vlag (indien nodig) in te stellen voordat u het eerste item toevoegt. Anders kunt u het later niet meer wijzigen',
    },
  },
  healthCheck: {
    index: 'Gezondheidscheck',
    overview: 'Overzicht',
    general: 'Details',
    add: 'Gezondheidscheck Aanmaken',
    create: 'Nieuwe Gezondheidscheck Aanmaken',
    edit: 'Gezondheidscheck Bewerken',
    empty: 'Het lijkt erop dat u nog geen Gezondheidschecks heeft toegevoegd. Maak nu uw eerste gezondheidscheck aan!',
    table: {
      venues: 'Locaties',
      customerGroup: 'Klantengroep',
      lastRunAt: 'Laatst Uitgevoerd Op',
      status: 'Status',
      errorList: 'Fouten',
      article: 'Artikel',
      category: 'Categorie',
      type: 'Type',
    },
    form: {
      venues: 'Locaties',
      customerGroup: 'Klantengroep',
    },
  },
};
